/**-----------------------------------------------------------------------------------------
* Copyright © 2020 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import { Injectable, Directive, TemplateRef, Optional, isDevMode, Component, SkipSelf, Host, ElementRef, Input, ViewChild, HostBinding, ViewChildren, ContentChildren, EventEmitter, Output, ContentChild, HostListener, Renderer2, ChangeDetectorRef, NgZone, Inject, QueryList, ViewEncapsulation, NgModule, forwardRef } from '@angular/core';
import { LocalizationService, L10N_PREFIX, ComponentMessages } from '@progress/kendo-angular-l10n';
import { Keys, hasObservers, DraggableDirective, DraggableModule } from '@progress/kendo-angular-common';
import { trigger, state, style, transition, animate, AUTO_STYLE, AnimationBuilder } from '@angular/animations';
import { Subject, BehaviorSubject, Subscription, of } from 'rxjs';
import { take, tap, filter, switchMap, delay, takeUntil, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';

/**
 * Represents the expand modes of the PanelBar.
 * By default, the expand mode is set to `multiple`.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@progress/kendo-angular-l10n';
import * as ɵngcc3 from '@progress/kendo-angular-common';
import * as ɵngcc4 from '@angular/animations';
import * as ɵngcc5 from '@progress/kendo-angular-progressbar';

const _c0 = ["header"];
const _c1 = ["contentWrapper"];
function PanelBarItemComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 7);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.iconClasses);
} }
function PanelBarItemComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 8);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r2.imageUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function PanelBarItemComponent_ng_template_5_Template(rf, ctx) { }
function PanelBarItemComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("k-icon", true)("k-i-arrow-n", ctx_r4.expanded)("k-panelbar-collapse", ctx_r4.expanded)("k-i-arrow-s", !ctx_r4.expanded)("k-panelbar-expand", !ctx_r4.expanded);
} }
function PanelBarItemComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("overflow", ctx_r7.contentOverflow)("height", ctx_r7.contentHeight);
} }
function PanelBarItemComponent_div_7_div_3_ng_template_1_Template(rf, ctx) { }
const _c2 = function (a0, a1, a2, a3, a4, a5) { return { title: a0, id: a1, icon: a2, imageUrl: a3, disabled: a4, content: a5 }; };
const _c3 = function (a0) { return { $implicit: a0 }; };
function PanelBarItemComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, PanelBarItemComponent_div_7_div_3_ng_template_1_Template, 0, 0, "ng-template", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("overflow", ctx_r8.contentOverflow)("height", ctx_r8.contentHeight);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.contentTemplate.first.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(13, _c3, ɵngcc0.ɵɵpureFunction6(6, _c2, ctx_r8.title, ctx_r8.id, ctx_r8.icon, ctx_r8.imageUrl, ctx_r8.disabled, ctx_r8.content)));
} }
function PanelBarItemComponent_div_7_div_4_ng_container_1_kendo_panelbar_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-panelbar-item", 17);
} if (rf & 2) {
    const item_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("title", item_r13.title)("id", item_r13.id)("icon", item_r13.icon)("iconClass", item_r13.iconClass)("imageUrl", item_r13.imageUrl)("selected", !!item_r13.selected)("expanded", !!item_r13.expanded)("disabled", !!item_r13.disabled)("template", ctx_r14.template)("items", item_r13.children)("content", item_r13.content);
} }
function PanelBarItemComponent_div_7_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PanelBarItemComponent_div_7_div_4_ng_container_1_kendo_panelbar_item_1_Template, 1, 11, "kendo-panelbar-item", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r13.hidden);
} }
function PanelBarItemComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtemplate(1, PanelBarItemComponent_div_7_div_4_ng_container_1_Template, 2, 1, "ng-container", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("overflow", ctx_r9.contentOverflow)("height", ctx_r9.contentHeight);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.items);
} }
function PanelBarItemComponent_div_7_div_5_ng_template_1_Template(rf, ctx) { }
function PanelBarItemComponent_div_7_div_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r17.content);
} }
function PanelBarItemComponent_div_7_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, PanelBarItemComponent_div_7_div_5_ng_template_1_Template, 0, 0, "ng-template", 14);
    ɵngcc0.ɵɵtemplate(2, PanelBarItemComponent_div_7_div_5_ng_template_2_Template, 1, 1, "ng-template", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("overflow", ctx_r10.contentOverflow)("height", ctx_r10.contentHeight);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(14, _c3, ɵngcc0.ɵɵpureFunction6(7, _c2, ctx_r10.title, ctx_r10.id, ctx_r10.icon, ctx_r10.imageUrl, ctx_r10.disabled, ctx_r10.content)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.template);
} }
function PanelBarItemComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", null, 9);
    ɵngcc0.ɵɵtemplate(2, PanelBarItemComponent_div_7_div_2_Template, 2, 4, "div", 10);
    ɵngcc0.ɵɵtemplate(3, PanelBarItemComponent_div_7_div_3_Template, 2, 15, "div", 11);
    ɵngcc0.ɵɵtemplate(4, PanelBarItemComponent_div_7_div_4_Template, 2, 5, "div", 10);
    ɵngcc0.ɵɵtemplate(5, PanelBarItemComponent_div_7_div_5_Template, 3, 16, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@toggle", ctx_r5.state);
    ɵngcc0.ɵɵattribute("role", "group")("aria-hidden", !ctx_r5.disabled && !ctx_r5.expanded);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.hasChildItems && !(ctx_r5.items == null ? null : ctx_r5.items.length));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.hasContent && !ctx_r5.content);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.hasItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.content);
} }
const _c4 = [[["kendo-panelbar-item"]]];
const _c5 = ["kendo-panelbar-item"];
function PanelBarComponent_ng_content_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "contentChildItems && !items"]);
} }
function PanelBarComponent_ng_template_1_ng_container_0_kendo_panelbar_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-panelbar-item", 4);
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("title", item_r3.title)("id", item_r3.id)("icon", item_r3.icon)("iconClass", item_r3.iconClass)("imageUrl", item_r3.imageUrl)("selected", !!item_r3.selected)("expanded", !!item_r3.expanded)("disabled", !!item_r3.disabled)("template", ctx_r4.templateRef)("items", item_r3.children)("content", item_r3.content);
} }
function PanelBarComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PanelBarComponent_ng_template_1_ng_container_0_kendo_panelbar_item_1_Template, 1, 11, "kendo-panelbar-item", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r3.hidden);
} }
function PanelBarComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PanelBarComponent_ng_template_1_ng_container_0_Template, 2, 1, "ng-container", 2);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.items);
} }
function SplitterPaneComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function SplitterPaneComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
} }
const _c6 = ["*"];
function SplitterComponent_ng_container_1_kendo_splitter_bar_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-splitter-bar", 2);
} if (rf & 2) {
    const index_r2 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("index", index_r2)("orientation", ctx_r4.orientation);
} }
function SplitterComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SplitterComponent_ng_container_1_kendo_splitter_bar_1_Template, 1, 2, "kendo-splitter-bar", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const last_r3 = ctx.last;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r3);
} }
const _c7 = [[["kendo-splitter-pane"]]];
const _c8 = ["kendo-splitter-pane"];
const _c9 = ["tablist"];
const _c10 = ["tabHeadingContainer"];
function TabStripComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TabStripComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TabStripComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TabStripComponent_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, TabStripComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function TabStripComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TabStripComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TabStripComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TabStripComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, TabStripComponent_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function TabStripComponent_ng_template_2_li_2_ng_template_4_Template(rf, ctx) { }
function TabStripComponent_ng_template_2_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 7, 8);
    ɵngcc0.ɵɵlistener("click", function TabStripComponent_ng_template_2_li_2_Template_li_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const i_r13 = ctx.index; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onTabClick($event, i_r13); });
    ɵngcc0.ɵɵelementStart(2, "span", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, TabStripComponent_ng_template_2_li_2_ng_template_4_Template, 0, 0, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r12 = ctx.$implicit;
    const i_r13 = ctx.index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("k-item", true)("k-state-default", true)("k-state-active", tab_r12.active)("k-state-disabled", tab_r12.disabled);
    ɵngcc0.ɵɵproperty("id", ctx_r11.tabId(i_r13))("tabIndex", tab_r12.active ? 0 : 0 - 1)("ngClass", tab_r12.cssClass);
    ɵngcc0.ɵɵattribute("aria-selected", tab_r12.active)("aria-controls", ctx_r11.tabPanelId(i_r13))("aria-disabled", tab_r12.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(tab_r12.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r12.tabTitle == null ? null : tab_r12.tabTitle.templateRef);
} }
function TabStripComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 4, 5);
    ɵngcc0.ɵɵlistener("keydown", function TabStripComponent_ng_template_2_Template_ul_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onKeyDown($event); });
    ɵngcc0.ɵɵtemplate(2, TabStripComponent_ng_template_2_li_2_Template, 5, 16, "li", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("justify-content", ctx_r3.tabsAlignment);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.tabs);
} }
function TabStripComponent_ng_template_4_ng_template_0_div_0_ng_template_1_Template(rf, ctx) { }
function TabStripComponent_ng_template_4_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, TabStripComponent_ng_template_4_ng_template_0_div_0_ng_template_1_Template, 0, 0, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext();
    const tab_r21 = ctx_r25.$implicit;
    const i_r22 = ctx_r25.index;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("@state", tab_r21.active && ctx_r23._animate ? "active" : "inactive")("ngClass", ctx_r23.contentClass(tab_r21.active))("tabIndex", 0)("id", ctx_r23.tabPanelId(i_r22));
    ɵngcc0.ɵɵattribute("aria-hidden", !tab_r21.active)("aria-expanded", tab_r21.active)("aria-labelledby", ctx_r23.tabId(i_r22))("aria-disabled", tab_r21.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r21.tabContent == null ? null : tab_r21.tabContent.templateRef);
} }
function TabStripComponent_ng_template_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TabStripComponent_ng_template_4_ng_template_0_div_0_Template, 2, 9, "div", 12);
} if (rf & 2) {
    const tab_r21 = ctx.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", tab_r21.active || ctx_r20.keepTabContent);
} }
function TabStripComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TabStripComponent_ng_template_4_ng_template_0_Template, 1, 1, "ng-template", 11);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.tabs);
} }
function DrawerComponent_div_0_ng_container_1_1_ng_template_0_Template(rf, ctx) { }
function DrawerComponent_div_0_ng_container_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DrawerComponent_div_0_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 4);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.headerTemplate == null ? null : ctx_r3.headerTemplate.templateRef);
} }
function DrawerComponent_div_0_ng_container_1_3_ng_template_0_Template(rf, ctx) { }
function DrawerComponent_div_0_ng_container_1_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DrawerComponent_div_0_ng_container_1_3_ng_template_0_Template, 0, 0, "ng-template", 4);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.footerTemplate == null ? null : ctx_r4.footerTemplate.templateRef);
} }
function DrawerComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DrawerComponent_div_0_ng_container_1_1_Template, 1, 1, undefined, 2);
    ɵngcc0.ɵɵelement(2, "ul", 3);
    ɵngcc0.ɵɵtemplate(3, DrawerComponent_div_0_ng_container_1_3_Template, 1, 1, undefined, 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.headerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("items", ctx_r1.items)("mini", ctx_r1.mini)("expanded", ctx_r1.expanded)("itemTemplate", ctx_r1.itemTemplate == null ? null : ctx_r1.itemTemplate.templateRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.footerTemplate);
} }
function DrawerComponent_div_0_2_ng_template_0_Template(rf, ctx) { }
function DrawerComponent_div_0_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DrawerComponent_div_0_2_ng_template_0_Template, 0, 0, "ng-template", 4);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.drawerTemplate == null ? null : ctx_r2.drawerTemplate.templateRef);
} }
function DrawerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, DrawerComponent_div_0_ng_container_1_Template, 4, 6, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, DrawerComponent_div_0_2_Template, 1, 1, undefined, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r0.drawerWidth, "px");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.drawerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.drawerTemplate);
} }
function DrawerContainerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function DrawerContainerComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.closeDrawer(); });
    ɵngcc0.ɵɵelementEnd();
} }
var I18N_11;
if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
    /**
     * @desc The text for the optional segment of the step label
     * @meaning kendo.stepper.optional
     */ 
    const MSG_EXTERNAL_9222129954657106830$$DIST_FESM2015_INDEX_JS_12 = goog.getMsg("Optional");
    I18N_11 = MSG_EXTERNAL_9222129954657106830$$DIST_FESM2015_INDEX_JS_12;
}
else {
    I18N_11 = $localize `:kendo.stepper.optional|The text for the optional segment of the step label␟5662ca90a1b7d36b2f55d6e21c0f4f7e166291af␟9222129954657106830:Optional`;
}
const _c13 = ["optional", I18N_11];
function StepperComponent_kendo_progressbar_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "kendo-progressbar", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("animation", ctx_r0.progressAnimation)("max", ctx_r0.steps.length - 1)("label", false)("orientation", ctx_r0.orientation)("reverse", !ctx_r0.isHorizontal)("value", ctx_r0.currentStep)("ngStyle", ctx_r0.progressBarStyling);
    ɵngcc0.ɵɵattribute("aria-hidden", true);
} }
function AvatarComponent_ng_content_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "customAvatar"]);
} }
function AvatarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ctx_r1.width)("height", ctx_r1.height)("background-image", ctx_r1.imageUrl);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.cssStyle);
} }
function AvatarComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r2.cssStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.initials.substring(0, 2));
} }
function AvatarComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r3.cssStyle)("ngClass", ctx_r3.iconClasses());
} }
function CardActionsComponent_ng_content_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "!actions"]);
} }
function CardActionsComponent_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 2);
    ɵngcc0.ɵɵlistener("click", function CardActionsComponent_ng_container_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const action_r4 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onClick(action_r4); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r4 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("k-primary", action_r4.primary)("k-flat", action_r4.flat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", action_r4.text, " ");
} }
function CardActionsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CardActionsComponent_ng_container_1_button_1_Template, 2, 5, "button", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.actions);
} }
function CardActionsComponent_2_ng_template_0_Template(rf, ctx) { }
function CardActionsComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, CardActionsComponent_2_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.actions);
} }
const _c14 = ["kendoDrawerItem", ""];
function DrawerItemComponent_0_ng_template_0_Template(rf, ctx) { }
function DrawerItemComponent_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DrawerItemComponent_0_ng_template_0_Template, 0, 0, "ng-template", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c3, ctx_r0.item));
} }
function DrawerItemComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementStart(2, "span", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.iconClasses(ctx_r4.item.icon));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.item.text);
} }
function DrawerItemComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r5.iconClasses(ctx_r5.item.icon));
} }
function DrawerItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DrawerItemComponent_ng_template_1_ng_container_0_Template, 4, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(1, DrawerItemComponent_ng_template_1_ng_container_1_Template, 2, 1, "ng-container", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.mini && !ctx_r2.expanded);
} }
const _c15 = ["kendoDrawerList", ""];
function DrawerListComponent_ng_container_0_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 3);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const item_r1 = ctx_r5.$implicit;
    const idx_r2 = ctx_r5.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("item", item_r1)("index", idx_r2)("mini", ctx_r3.mini)("expanded", ctx_r3.expanded)("itemTemplate", ctx_r3.itemTemplate)("ngClass", item_r1.cssClass)("ngStyle", item_r1.cssStyle);
    ɵngcc0.ɵɵattribute("data-kendo-drawer-index", idx_r2);
} }
function DrawerListComponent_ng_container_0_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtext(1, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", item_r1.cssClass)("ngStyle", item_r1.cssStyle);
} }
function DrawerListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DrawerListComponent_ng_container_0_li_1_Template, 1, 8, "li", 1);
    ɵngcc0.ɵɵtemplate(2, DrawerListComponent_ng_container_0_li_2_Template, 2, 2, "li", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r1.separator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.separator);
} }
const _c16 = ["stepLink"];
const _c17 = ["kendoStepperStep", ""];
function StepperStepComponent_2_ng_template_0_Template(rf, ctx) { }
const _c18 = function (a0, a1) { return { $implicit: a0, index: a1 }; };
function StepperStepComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, StepperStepComponent_2_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.stepTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c18, ctx_r1.step, ctx_r1.index));
} }
function StepperStepComponent_ng_container_3_span_1_1_ng_template_0_Template(rf, ctx) { }
function StepperStepComponent_ng_container_3_span_1_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, StepperStepComponent_ng_container_3_span_1_1_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.indicatorTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c18, ctx_r6.step, ctx_r6.index));
} }
function StepperStepComponent_ng_container_3_span_1_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.indicatorIconClasses);
} }
function StepperStepComponent_ng_container_3_span_1_ng_container_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.indicatorText);
} }
function StepperStepComponent_ng_container_3_span_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StepperStepComponent_ng_container_3_span_1_ng_container_2_span_1_Template, 1, 1, "span", 7);
    ɵngcc0.ɵɵtemplate(2, StepperStepComponent_ng_container_3_span_1_ng_container_2_span_2_Template, 2, 1, "span", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.showIndicatorIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.showIndicatorIcon);
} }
function StepperStepComponent_ng_container_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtemplate(1, StepperStepComponent_ng_container_3_span_1_1_Template, 1, 5, undefined, 2);
    ɵngcc0.ɵɵtemplate(2, StepperStepComponent_ng_container_3_span_1_ng_container_2_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵstyleProp("transition-duration", ctx_r4.transitionDuration, "ms");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.indicatorTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.indicatorTemplate);
} }
function StepperStepComponent_ng_container_3_span_2_1_ng_template_0_Template(rf, ctx) { }
function StepperStepComponent_ng_container_3_span_2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, StepperStepComponent_ng_container_3_span_2_1_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r11.labelTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c18, ctx_r11.step, ctx_r11.index));
} }
function StepperStepComponent_ng_container_3_span_2_ng_container_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.step.label);
} }
function StepperStepComponent_ng_container_3_span_2_ng_container_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 16);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r15.validationIconClasses);
} }
function StepperStepComponent_ng_container_3_span_2_ng_container_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("(", ctx_r16.optionalText, ")");
} }
function StepperStepComponent_ng_container_3_span_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StepperStepComponent_ng_container_3_span_2_ng_container_2_span_1_Template, 2, 1, "span", 12);
    ɵngcc0.ɵɵtemplate(2, StepperStepComponent_ng_container_3_span_2_ng_container_2_span_2_Template, 1, 1, "span", 13);
    ɵngcc0.ɵɵtemplate(3, StepperStepComponent_ng_container_3_span_2_ng_container_2_span_3_Template, 2, 1, "span", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.showLabelText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.showLabelIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.step.optional);
} }
function StepperStepComponent_ng_container_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtemplate(1, StepperStepComponent_ng_container_3_span_2_1_Template, 1, 5, undefined, 2);
    ɵngcc0.ɵɵtemplate(2, StepperStepComponent_ng_container_3_span_2_ng_container_2_Template, 4, 3, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.labelTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.labelTemplate);
} }
function StepperStepComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StepperStepComponent_ng_container_3_span_1_Template, 3, 4, "span", 4);
    ɵngcc0.ɵɵtemplate(2, StepperStepComponent_ng_container_3_span_2_Template, 3, 2, "span", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showIndicator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showLabel);
} }
const _c19 = ["kendoStepperList", ""];
function StepperListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "li", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const idx_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("max-width", ctx_r0.maxStepWidth, "%")("max-height", ctx_r0.maxStepHeight, "%");
    ɵngcc0.ɵɵclassProp("k-step-first", idx_r2 === 0)("k-step-last", idx_r2 === ctx_r0.steps.length - 1)("k-step-done", idx_r2 < ctx_r0.currentStep)("k-step-current", idx_r2 === ctx_r0.currentStep)("k-step-optional", step_r1.optional)("k-step-disabled", step_r1.disabled);
    ɵngcc0.ɵɵproperty("type", ctx_r0.stepType)("step", step_r1)("index", idx_r2)("current", ctx_r0.currentStep)("successIcon", ctx_r0.successIcon)("errorIcon", ctx_r0.errorIcon)("indicatorTemplate", ctx_r0.indicatorTemplate)("labelTemplate", ctx_r0.labelTemplate)("stepTemplate", ctx_r0.stepTemplate)("ngClass", step_r1.cssClass)("ngStyle", step_r1.cssStyle);
    ɵngcc0.ɵɵattribute("data-kendo-stepper-index", idx_r2);
} }
var PanelBarExpandMode;
(function (PanelBarExpandMode) {
    /**
     * Allows you to expand only one item at a time.
     * When you expand an item, the item that was previously expanded is coll.
     */
    PanelBarExpandMode[PanelBarExpandMode["Single"] = 0] = "Single";
    /**
     * Allows you to expand only one item at a time and requires you to set the `height` property.
     * The expanded area occupies the entire height of the PanelBar.
     */
    PanelBarExpandMode[PanelBarExpandMode["Full"] = 1] = "Full";
    /**
     * The default mode of the PanelBar.
     * Allows you to expand more than one item at a time. Items can also be toggled.
     */
    PanelBarExpandMode[PanelBarExpandMode["Multiple"] = 2] = "Multiple";
    /**
     * By default, the expand mode is set to `multiple`.
     */
    PanelBarExpandMode[PanelBarExpandMode["Default"] = 2] = "Default";
})(PanelBarExpandMode || (PanelBarExpandMode = {}));

/**
 * @hidden
 */
let nextPanelbarId = 0;
/**
 * @hidden
 */
class PanelBarService {
    constructor() {
        this.parentSource = new Subject();
        this.keepContentSource = new BehaviorSubject(false);
        this.childSource = new Subject();
        this.parent$ = this.parentSource.asObservable();
        this.children$ = this.childSource.asObservable();
        this.keepContent$ = this.keepContentSource.asObservable();
        this.pbId = nextPanelbarId++;
    }
    onKeepContent(keepContent) {
        this.keepContentSource.next(keepContent);
    }
    onSelect(event) {
        this.childSource.next(event);
    }
    onFocus() {
        this.parentSource.next(true);
    }
    onBlur() {
        this.parentSource.next(false);
    }
}
PanelBarService.ɵfac = function PanelBarService_Factory(t) { return new (t || PanelBarService)(); };
PanelBarService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PanelBarService, factory: PanelBarService.ɵfac });
/** @nocollapse */
PanelBarService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Represents the content template of the declaratively initialized PanelBar items.
 * The content can be expanded or collapsed through the item.
 */
class PanelBarContentDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
PanelBarContentDirective.ɵfac = function PanelBarContentDirective_Factory(t) { return new (t || PanelBarContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
PanelBarContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PanelBarContentDirective, selectors: [["", "kendoPanelBarContent", ""]] });
/** @nocollapse */
PanelBarContentDirective.ctorParameters = () => [
    { type: TemplateRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarContentDirective, [{
        type: Directive,
        args: [{
                selector: "[kendoPanelBarContent]"
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

/**
 * Represents the template directive of the PanelBar which helps to customize the item title
 * ([more information and example]({% slug templates_panelbar %}#toc-customizing-the-appearance-of-the-title)).
 *
 * @example
 * ```ts-preview
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *        <kendo-panelbar>
 *            <kendo-panelbar-item [title]="'Paris'" [expanded]="true">
 *                <ng-template kendoPanelBarItemTitle>
 *                    Additional Content
 *                </ng-template>
 *            </kendo-panelbar-item>
 *        </kendo-panelbar>
 *     `
 * })
 *
 * class AppComponent {}
 *
 * ```
 */
class PanelBarItemTitleDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
PanelBarItemTitleDirective.ɵfac = function PanelBarItemTitleDirective_Factory(t) { return new (t || PanelBarItemTitleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
PanelBarItemTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PanelBarItemTitleDirective, selectors: [["", "kendoPanelBarItemTitle", ""]] });
/** @nocollapse */
PanelBarItemTitleDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarItemTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoPanelBarItemTitle]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

let nextId = 0;
const parsePanelBarItems = (data) => {
    return data.map((item) => {
        if (!item.id) {
            item.id = `default-${nextId++}`;
        }
        if (item.children) {
            item.children = parsePanelBarItems(item.children);
        }
        return item;
    });
};
var util = {
    parsePanelBarItems
};
/**
 * @hidden
 */
const isPresent = (value) => value !== null && value !== undefined;

const focusableRegex = /^(?:a|input|select|option|textarea|button|object)$/i;
const toClassList = (classNames) => String(classNames).trim().split(' ');
/**
 * @hidden
 */
const isFocusable = (element) => {
    if (element.tagName) {
        const tagName = element.tagName.toLowerCase();
        const tabIndex = element.getAttribute('tabIndex');
        const skipTab = tabIndex === '-1';
        let focusable = tabIndex !== null && !skipTab;
        if (focusableRegex.test(tagName)) {
            focusable = !element.disabled && !skipTab;
        }
        return focusable;
    }
    return false;
};
/**
 * @hidden
 */
const hasClass = (element, className) => Boolean(toClassList(element.className).find((name) => name === className));
const closestInScope = (target, targetAttr, predicate, scope) => {
    while (target && target !== scope && !predicate(target, targetAttr)) {
        target = target.parentNode;
    }
    if (target !== scope) {
        return target;
    }
};
/**
 * @hidden
 */
const itemIndex = (item, indexAttr) => +item.getAttribute(indexAttr);
const hasItemIndex = (item, indexAttr) => isPresent(item.getAttribute(indexAttr));
/**
 * @hidden
 */
const closestItem = (target, targetAttr, scope) => closestInScope(target, targetAttr, hasItemIndex, scope);

/**
 * @hidden
 */
let nextId$1 = 0;
/**
 * Represents the items of the PanelBar.
 */
class PanelBarItemComponent {
    constructor(parent, eventService, element) {
        this.parent = parent;
        this.eventService = eventService;
        this.element = element;
        /**
         * Sets the title of the PanelBar item ([see example]({% slug items_panelbar %}#toc-titles)).
         */
        this.title = 'Untitled';
        /**
         * Allows the component to set the `"id"` property to each item.
         * Used to set the `id` attributes of the nested elements and to enable the WAI-ARIA support.
         */
        this.id = `default-${nextId$1++}`;
        /**
         * Defines the icon that will be rendered next to the title ([see example]({% slug items_panelbar %}#toc-title-icons)).
         */
        this.icon = '';
        /**
         * Defines  the icon that will be rendered next to the title by using a custom CSS class
         * ([see example]({% slug items_panelbar %}#toc-title-icons)).
         */
        this.iconClass = '';
        /**
         * Defines the location of the image that will be displayed next to the title
         * ([see example]({% slug items_panelbar %}#toc-title-images)).
         */
        this.imageUrl = '';
        /**
         * When set to `true`, disables a PanelBar item ([see example]({% slug items_panelbar %}#toc-disabled-state)).
         */
        this.disabled = false;
        /**
         * Sets the selected state of a PanelBar item ([see example]({% slug items_panelbar %}#toc-selected-state)).
         */
        this.selected = false;
        this.keepContent = false;
        this.hasChildItems = false;
        this.hasItems = false;
        this.hasContent = false;
        this.state = "inactive";
        this.role = "treeitem";
        this.titleAttribute = null; // tslint:disable-line
        this.focused = false;
        this.wrapperFocused = false;
        this.subscriptions = new Subscription(() => { });
        this._expanded = false;
        this.subscriptions.add(eventService.parent$.subscribe(focused => this.onWrapperFocusChange(focused)));
        this.subscriptions.add(eventService.keepContent$.subscribe(keepContent => this.keepContent = keepContent));
        this.wrapperFocused = parent ? parent.focused : false;
    }
    /**
     * When set to `true`, expands the PanelBar item ([see example]({% slug items_panelbar %}#toc-expanded-state)).
     */
    set expanded(value) {
        const activeState = this.animate ? "active" : "activeWithoutAnimation";
        this.state = value ? activeState : "inactive";
        if (!this.keepContent) {
            this.toggleExpandedChildAnimations(value);
        }
        this._expanded = value;
    }
    get expanded() {
        return this._expanded;
    }
    get animate() {
        return this.eventService.animate;
    }
    get kItemClass() {
        return true;
    }
    get kStateDefaultClass() {
        return !this.disabled;
    }
    get kStateDisabledClass() {
        return this.disabled;
    }
    get kStateExpandedClass() {
        return !this.disabled && this.expanded && (this.hasChildItems || this.hasContent);
    }
    get itemId() {
        return 'k-panelbar-' + this.eventService.pbId + '-item-' + this.id;
    }
    get ariaExpanded() {
        return (this.hasChildItems || this.hasContent) ? !this.disabled && this.expanded : null;
    }
    get ariaSelected() {
        return !this.disabled && this.selected;
    }
    get ariaDisabled() {
        return this.disabled ? true : null;
    }
    /**
     * @hidden
     */
    get titleTemplate() {
        return this.titleTemplates.length > 0 ? this.titleTemplates.toArray()[0].templateRef : undefined;
    }
    /**
     * @hidden
     */
    headerHeight() {
        return this.element.nativeElement.offsetHeight - (this.contentWrapper ? this.contentWrapper.nativeElement.offsetHeight : 0);
    }
    /**
     * @hidden
     */
    ngAfterContentChecked() {
        this.hasItems = this.items && this.items.filter(item => !item.hidden).length > 0;
        this.hasChildItems = this.contentItems.filter(item => item !== this).length > 0 || this.hasItems;
        this.hasContent = (this.contentTemplate !== undefined && this.contentTemplate.length > 0) ||
            this.content !== undefined;
        this.validateConfiguration();
    }
    /**
     * @hidden
     */
    ngAfterViewChecked() {
        if (this.items) {
            this.childrenItems = this.viewChildItems.toArray();
        }
        else {
            this.childrenItems = this.contentItems.filter(item => item !== this);
        }
    }
    /**
     * @hidden
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    /**
     * @hidden
     */
    onItemAction() {
        if (!this.disabled) {
            this.eventService.onSelect(this);
        }
    }
    /**
     * @hidden
     */
    onItemClick(e) {
        if (!isFocusable(e.target)) {
            this.onItemAction();
        }
    }
    /**
     * @hidden
     */
    get iconClasses() {
        let icon = this.icon ? 'k-i-' + this.icon : null;
        return {
            [icon || this.iconClass]: true
        };
    }
    /**
     * @hidden
     */
    serialize() {
        return {
            content: this.content,
            disabled: this.disabled,
            expanded: this.expanded,
            focused: this.focused,
            icon: this.icon,
            iconClass: this.iconClass,
            id: this.id,
            imageUrl: this.imageUrl,
            selected: this.selected,
            title: this.title
        };
    }
    /**
     * @hidden
     */
    subTreeViewItems() {
        let subTree = [];
        this.viewChildItems.forEach(item => {
            subTree = subTree.concat(item.subTreeViewItems());
            subTree.push(item);
        });
        return subTree;
    }
    /**
     * @hidden
     */
    validateConfiguration() {
        if (isDevMode()) {
            if (this.content && (this.contentTemplate !== undefined && this.contentTemplate.length > 0)) {
                throw new Error("Invalid configuration: mixed template components and component property.");
            }
        }
    }
    /**
     * @hidden
     */
    toggleAnimationState(value) {
        if (!this.animate) {
            return;
        }
        this.state = value && this.eventService.expandMode !== PanelBarExpandMode.Single ? 'active' : 'activeWithoutAnimation';
    }
    /**
     * @hidden
     */
    toggleExpandedChildAnimations(value) {
        if (this.childrenItems) {
            this.childrenItems.forEach(child => {
                if (child.expanded) {
                    child.toggleAnimationState(value);
                    child.toggleExpandedChildAnimations(value);
                }
            });
        }
    }
    onWrapperFocusChange(focused) {
        this.wrapperFocused = focused;
    }
}
PanelBarItemComponent.ɵfac = function PanelBarItemComponent_Factory(t) { return new (t || PanelBarItemComponent)(ɵngcc0.ɵɵdirectiveInject(PanelBarItemComponent, 13), ɵngcc0.ɵɵdirectiveInject(PanelBarService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PanelBarItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PanelBarItemComponent, selectors: [["kendo-panelbar-item"]], contentQueries: function PanelBarItemComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, PanelBarItemComponent, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, PanelBarContentDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, PanelBarItemTitleDirective, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentItems = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentTemplate = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.titleTemplates = _t);
    } }, viewQuery: function PanelBarItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
        ɵngcc0.ɵɵviewQuery(PanelBarItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.header = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.viewChildItems = _t);
    } }, hostVars: 14, hostBindings: function PanelBarItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.itemId);
        ɵngcc0.ɵɵattribute("role", ctx.role)("title", ctx.titleAttribute)("aria-expanded", ctx.ariaExpanded)("aria-selected", ctx.ariaSelected)("aria-disabled", ctx.ariaDisabled);
        ɵngcc0.ɵɵclassProp("k-item", ctx.kItemClass)("k-state-default", ctx.kStateDefaultClass)("k-state-disabled", ctx.kStateDisabledClass)("k-state-expanded", ctx.kStateExpandedClass);
    } }, inputs: { title: "title", id: "id", icon: "icon", iconClass: "iconClass", imageUrl: "imageUrl", disabled: "disabled", selected: "selected", expanded: "expanded", content: "content", items: "items", template: "template" }, exportAs: ["kendoPanelbarItem"], ngContentSelectors: _c5, decls: 8, vars: 14, consts: [[3, "click"], ["header", ""], ["class", "k-icon", 3, "ngClass", 4, "ngIf"], ["class", "k-image", "alt", "", 3, "src", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "k-icon", "k-i-arrow-n", "k-panelbar-collapse", "k-i-arrow-s", "k-panelbar-expand", 4, "ngIf"], [4, "ngIf"], [1, "k-icon", 3, "ngClass"], ["alt", "", 1, "k-image", 3, "src"], ["contentWrapper", ""], ["class", "k-panel k-group", 3, "overflow", "height", 4, "ngIf"], ["class", "k-content", 3, "overflow", "height", 4, "ngIf"], [1, "k-panel", "k-group"], [1, "k-content"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf"], [3, "title", "id", "icon", "iconClass", "imageUrl", "selected", "expanded", "disabled", "template", "items", "content", 4, "ngIf"], [3, "title", "id", "icon", "iconClass", "imageUrl", "selected", "expanded", "disabled", "template", "items", "content"], [3, "ngIf"]], template: function PanelBarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵelementStart(0, "span", 0, 1);
        ɵngcc0.ɵɵlistener("click", function PanelBarItemComponent_Template_span_click_0_listener($event) { return ctx.onItemClick($event); });
        ɵngcc0.ɵɵtemplate(2, PanelBarItemComponent_span_2_Template, 1, 1, "span", 2);
        ɵngcc0.ɵɵtemplate(3, PanelBarItemComponent_img_3_Template, 1, 1, "img", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵtemplate(5, PanelBarItemComponent_ng_template_5_Template, 0, 0, "ng-template", 4);
        ɵngcc0.ɵɵtemplate(6, PanelBarItemComponent_span_6_Template, 1, 10, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, PanelBarItemComponent_div_7_Template, 6, 7, "div", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-link", true)("k-header", !ctx.parent)("k-state-selected", !ctx.disabled && ctx.selected)("k-state-focused", !ctx.disabled && ctx.focused && ctx.wrapperFocused);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon || ctx.iconClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.titleTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasChildItems || ctx.hasContent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.keepContent || !ctx.disabled && ctx.expanded && (ctx.hasChildItems || ctx.hasContent));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgClass, ɵngcc1.NgForOf, PanelBarItemComponent], encapsulation: 2, data: { animation: [
            trigger('toggle', [
                state('inactive', style({ display: 'none' })),
                transition('* => active', [
                    style({ overflow: 'hidden', display: 'block', height: 0 }),
                    animate(200, style({ height: AUTO_STYLE }))
                ]),
                transition('active => *', [
                    style({ overflow: 'hidden', height: AUTO_STYLE }),
                    animate(200, style({ height: 0, display: 'none' }))
                ])
            ])
        ] } });
/** @nocollapse */
PanelBarItemComponent.ctorParameters = () => [
    { type: PanelBarItemComponent, decorators: [{ type: SkipSelf }, { type: Host }, { type: Optional }] },
    { type: PanelBarService },
    { type: ElementRef }
];
PanelBarItemComponent.propDecorators = {
    title: [{ type: Input }],
    id: [{ type: Input }],
    icon: [{ type: Input }],
    iconClass: [{ type: Input }],
    imageUrl: [{ type: Input }],
    disabled: [{ type: Input }],
    expanded: [{ type: Input }],
    selected: [{ type: Input }],
    content: [{ type: Input }],
    items: [{ type: Input }],
    template: [{ type: Input }],
    header: [{ type: ViewChild, args: ['header', {},] }],
    contentWrapper: [{ type: ViewChild, args: ['contentWrapper', {},] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    titleAttribute: [{ type: HostBinding, args: ['attr.title',] }],
    kItemClass: [{ type: HostBinding, args: ['class.k-item',] }],
    kStateDefaultClass: [{ type: HostBinding, args: ['class.k-state-default',] }],
    kStateDisabledClass: [{ type: HostBinding, args: ['class.k-state-disabled',] }],
    kStateExpandedClass: [{ type: HostBinding, args: ['class.k-state-expanded',] }],
    itemId: [{ type: HostBinding, args: ['id',] }],
    ariaExpanded: [{ type: HostBinding, args: ['attr.aria-expanded',] }],
    ariaSelected: [{ type: HostBinding, args: ['attr.aria-selected',] }],
    ariaDisabled: [{ type: HostBinding, args: ['attr.aria-disabled',] }],
    viewChildItems: [{ type: ViewChildren, args: [PanelBarItemComponent,] }],
    contentItems: [{ type: ContentChildren, args: [PanelBarItemComponent,] }],
    contentTemplate: [{ type: ContentChildren, args: [PanelBarContentDirective, { descendants: false },] }],
    titleTemplates: [{ type: ContentChildren, args: [PanelBarItemTitleDirective, { descendants: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarItemComponent, [{
        type: Component,
        args: [{
                animations: [
                    trigger('toggle', [
                        state('inactive', style({ display: 'none' })),
                        transition('* => active', [
                            style({ overflow: 'hidden', display: 'block', height: 0 }),
                            animate(200, style({ height: AUTO_STYLE }))
                        ]),
                        transition('active => *', [
                            style({ overflow: 'hidden', height: AUTO_STYLE }),
                            animate(200, style({ height: 0, display: 'none' }))
                        ])
                    ])
                ],
                exportAs: 'kendoPanelbarItem',
                selector: "kendo-panelbar-item",
                template: `<span
                #header
                [class.k-link]="true"
                [class.k-header]="!parent"
                [class.k-state-selected]="!disabled && selected"
                [class.k-state-focused]="!disabled && focused && wrapperFocused"
                (click)="onItemClick($event)">
            <span
                *ngIf="icon || iconClass"
                class="k-icon"
                [ngClass]="iconClasses">
            </span>
            <img
                *ngIf="imageUrl"
                class="k-image"
                [src]="imageUrl"
                alt="">
            {{title}}
            <ng-template [ngTemplateOutlet]="titleTemplate"></ng-template>
            <span *ngIf="hasChildItems || hasContent"
                [class.k-icon]="true"
                [class.k-i-arrow-n]="expanded"
                [class.k-panelbar-collapse]="expanded"
                [class.k-i-arrow-s]="!expanded"
                [class.k-panelbar-expand]="!expanded">
            </span>
        </span>
        <div #contentWrapper
            *ngIf="keepContent || (!disabled && expanded && (hasChildItems || hasContent))"
            [@toggle]="state"
            [attr.role]="'group'"
            [attr.aria-hidden]="!disabled && !expanded">
            <div
                *ngIf="hasChildItems && !items?.length"
                [style.overflow]="contentOverflow"
                [style.height]="contentHeight"
                class="k-panel k-group">
                    <ng-content select="kendo-panelbar-item"></ng-content>
            </div>
            <div
                *ngIf="hasContent && !content"
                [style.overflow]="contentOverflow"
                [style.height]="contentHeight"
                class="k-content">
                <ng-template
                    [ngTemplateOutlet]="contentTemplate.first.templateRef"
                    [ngTemplateOutletContext]="{
                        $implicit: {
                            title: title,
                            id: id,
                            icon: icon,
                            imageUrl: imageUrl,
                            disabled: disabled,
                            content: content
                        }
                    }">
                </ng-template>
            </div>
            <div *ngIf="hasItems"
                [style.overflow]="contentOverflow"
                [style.height]="contentHeight"
                class="k-panel k-group">
                <ng-container *ngFor="let item of items">
                    <kendo-panelbar-item *ngIf="!item.hidden"
                        [title]="item.title"
                        [id]="item.id"
                        [icon]="item.icon"
                        [iconClass]="item.iconClass"
                        [imageUrl]="item.imageUrl"
                        [selected]="!!item.selected"
                        [expanded]="!!item.expanded"
                        [disabled]="!!item.disabled"
                        [template]="template"
                        [items]="item.children"
                        [content]="item.content">
                    </kendo-panelbar-item>
                </ng-container>
            </div>
            <div
                *ngIf="content"
                [style.overflow]="contentOverflow"
                [style.height]="contentHeight"
                class="k-content">
                <ng-template
                    [ngTemplateOutlet]="template"
                    [ngTemplateOutletContext]="{
                        $implicit: {
                            title: title,
                            id: id,
                            icon: icon,
                            imageUrl: imageUrl,
                            disabled: disabled,
                            content: content
                        }
                    }">
                </ng-template>
                <ng-template [ngIf]="!template">{{content}}</ng-template>
            </div>
        </div>`
            }]
    }], function () { return [{ type: PanelBarItemComponent, decorators: [{
                type: SkipSelf
            }, {
                type: Host
            }, {
                type: Optional
            }] }, { type: PanelBarService }, { type: ɵngcc0.ElementRef }]; }, { title: [{
            type: Input
        }], id: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], imageUrl: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], titleAttribute: [{
            type: HostBinding,
            args: ['attr.title']
        }], expanded: [{
            type: Input
        }], kItemClass: [{
            type: HostBinding,
            args: ['class.k-item']
        }], kStateDefaultClass: [{
            type: HostBinding,
            args: ['class.k-state-default']
        }], kStateDisabledClass: [{
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], kStateExpandedClass: [{
            type: HostBinding,
            args: ['class.k-state-expanded']
        }], itemId: [{
            type: HostBinding,
            args: ['id']
        }], ariaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], ariaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], ariaDisabled: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], content: [{
            type: Input
        }], items: [{
            type: Input
        }], template: [{
            type: Input
        }], header: [{
            type: ViewChild,
            args: ['header', {}]
        }], contentWrapper: [{
            type: ViewChild,
            args: ['contentWrapper', {}]
        }], viewChildItems: [{
            type: ViewChildren,
            args: [PanelBarItemComponent]
        }], contentItems: [{
            type: ContentChildren,
            args: [PanelBarItemComponent]
        }], contentTemplate: [{
            type: ContentChildren,
            args: [PanelBarContentDirective, { descendants: false }]
        }], titleTemplates: [{
            type: ContentChildren,
            args: [PanelBarItemTitleDirective, { descendants: false }]
        }] }); })();

/**
 * Represents the template directive of the PanelBar which helps to customize the item content.
 */
class PanelBarItemTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
PanelBarItemTemplateDirective.ɵfac = function PanelBarItemTemplateDirective_Factory(t) { return new (t || PanelBarItemTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
PanelBarItemTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PanelBarItemTemplateDirective, selectors: [["", "kendoPanelBarItemTemplate", ""]] });
/** @nocollapse */
PanelBarItemTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarItemTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoPanelBarItemTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Represents the [Kendo UI PanelBar component for Angular]({% slug overview_panelbar %}).
 */
// TODO: add styles as input prop
class PanelBarComponent {
    constructor(elementRef, eventService, localization) {
        this.localization = localization;
        /**
         * Sets the expand mode of the PanelBar through the `PanelBarExpandMode` enum ([see example]({% slug expandmodes_panelbar %})).
         *
         * The available modes are:
         * - `"single"`&mdash;Expands only one item at a time. Expanding an item collapses the item that was previously expanded.
         * - `"multiple"`&mdash;The default mode of the PanelBar.
         * Expands more than one item at a time. Items can also be toggled.
         * - `"full"`&mdash;Expands only one item at a time.
         * The expanded area occupies the entire height of the PanelBar. Requires you to set the `height` property.
         */
        this.expandMode = PanelBarExpandMode.Default;
        /**
         * Allows the PanelBar to modify the selected state of the items.
         */
        this.selectable = true;
        /**
         * Sets the animate state of the PanelBar ([see example]({% slug animations_panelbar %})).
         */
        this.animate = true;
        /**
         * Sets the height of the component when the `"full"` expand mode is used.
         * This option is ignored in the `"multiple"` and `"single"` expand modes.
         */
        this.height = "400px";
        /**
         * Fires each time the user interacts with a PanelBar item
         * ([see example]({% slug routing_panelbar %}#toc-getting-the-selected-item)).
         * The event data contains all items that are modified.
         */
        this.stateChange = new EventEmitter();
        this.tabIndex = 0;
        this.role = "tree";
        this.activeDescendant = "";
        this.isViewInit = true;
        this.focused = false;
        this._keepItemContent = false;
        this.updateChildrenHeight = () => {
            let childrenHeight = 0;
            const panelbarHeight = this.elementRef.nativeElement.offsetHeight;
            const contentOverflow = this.expandMode === PanelBarExpandMode.Full ? 'auto' : 'visible';
            this.childrenItems.forEach(item => {
                childrenHeight += item.headerHeight();
            });
            this.childrenItems.forEach(item => {
                item.contentHeight = PanelBarExpandMode.Full === this.expandMode ? (panelbarHeight - childrenHeight) + "px" : 'auto';
                item.contentOverflow = contentOverflow;
            });
        };
        this.keyBindings = this.computedKeys;
        this.elementRef = elementRef;
        this.eventService = eventService;
        this.eventService.children$.subscribe(event => this.onItemAction(event));
    }
    /**
     * When set to `true`, the PanelBar renders the content of all items and they are persisted in the DOM
     * ([see example]({% slug templates_panelbar %}#toc-collections)).
     * By default, this option is set to `false`.
     */
    get keepItemContent() {
        return this._keepItemContent;
    }
    set keepItemContent(keepItemContent) {
        this._keepItemContent = keepItemContent;
        this.eventService.onKeepContent(keepItemContent);
    }
    /**
     * Sets the items of the PanelBar as an array of `PanelBarItemModel` instances
     * ([see example]({% slug items_panelbar %})).
     */
    set items(data) {
        if (data) {
            this._items = util.parsePanelBarItems(data);
        }
    }
    get items() {
        return this._items;
    }
    get hostHeight() {
        return this.expandMode === PanelBarExpandMode.Full ? this.height : 'auto';
    }
    get overflow() {
        return this.expandMode === PanelBarExpandMode.Full ? "hidden" : "visible";
    }
    get dir() {
        return this.localization.rtl ? 'rtl' : 'ltr';
    }
    /**
     * @hidden
     */
    invertKeys(original, inverted) {
        return this.localization.rtl ? inverted : original;
    }
    get computedKeys() {
        return {
            [Keys.Space]: () => this.selectFocusedItem(),
            [Keys.Enter]: () => this.selectFocusedItem(),
            [Keys.ArrowUp]: () => this.focusPreviousItem(),
            [this.invertKeys(Keys.ArrowLeft, Keys.ArrowRight)]: () => this.collapseItem(),
            [Keys.ArrowDown]: () => this.focusNextItem(),
            [this.invertKeys(Keys.ArrowRight, Keys.ArrowLeft)]: () => this.expandItem(),
            [Keys.End]: () => this.focusLastItem(),
            [Keys.Home]: () => this.focusFirstItem()
        };
    }
    ngOnDestroy() {
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
    }
    ngOnInit() {
        this.localizationChangeSubscription = this.localization
            .changes.subscribe(() => this.keyBindings = this.computedKeys);
        this.eventService.animate = this.animate;
        this.eventService.expandMode = this.expandMode;
    }
    ngAfterViewChecked() {
        if (this.items) {
            this.childrenItems = this.viewChildItems.toArray();
            this.allItems = this.viewItems;
        }
        else {
            this.childrenItems = this.contentChildItems.toArray();
            this.allItems = this.contentItems.toArray();
        }
        if (this.isViewInit && this.childrenItems.length) {
            this.isViewInit = false;
            setTimeout(() => this.updateChildrenHeight());
        }
        this.validateConfiguration();
    }
    ngOnChanges(changes) {
        if (changes['height'] || changes['expandMode'] || changes["items"]) { // tslint:disable-line
            if (this.childrenItems) {
                setTimeout(this.updateChildrenHeight);
            }
        }
        if (changes.animate) {
            this.eventService.animate = this.animate;
        }
        if (changes.expandMode) {
            this.eventService.expandMode = this.expandMode;
        }
    }
    get templateRef() {
        return this.template ? this.template.templateRef : undefined;
    }
    /**
     * @hidden
     */
    onComponentClick(event) {
        const itemClicked = this.visibleItems().some((item) => {
            return item.header.nativeElement.contains(event.target);
        });
        if (!this.focused && itemClicked) {
            this.elementRef.nativeElement.focus();
        }
    }
    /**
     * @hidden
     */
    onComponentFocus() {
        this.eventService.onFocus();
        this.focused = true;
        if (this.allItems.length > 0) {
            const visibleItems = this.visibleItems();
            const focusedItems = visibleItems.filter(item => item.focused);
            if (!focusedItems.length && visibleItems.length > 0) {
                visibleItems[0].focused = true;
                this.activeDescendant = visibleItems[0].itemId;
            }
        }
    }
    /**
     * @hidden
     */
    onComponentBlur() {
        this.eventService.onBlur();
        this.focused = false;
        this.activeDescendant = "";
    }
    /**
     * @hidden
     */
    onComponentKeyDown(event) {
        if (event.target === this.elementRef.nativeElement) {
            if (event.keyCode === Keys.Space || event.keyCode === Keys.ArrowUp || event.keyCode === Keys.ArrowDown ||
                event.keyCode === Keys.ArrowLeft || event.keyCode === Keys.ArrowRight || event.keyCode === Keys.Home ||
                event.keyCode === Keys.End || event.keyCode === Keys.PageUp || event.keyCode === Keys.PageDown) {
                event.preventDefault();
            }
            const handler = this.keyBindings[event.keyCode];
            //TODO: check if next item is disabled and skip operation?
            if (handler) {
                handler();
            }
        }
    }
    get viewItems() {
        let treeItems = [];
        this.viewChildItems.toArray().forEach(item => {
            treeItems.push(item);
            treeItems = treeItems.concat(item.subTreeViewItems());
        });
        return treeItems;
    }
    validateConfiguration() {
        if (isDevMode()) {
            if (this.items && (this.contentItems && this.contentItems.length > 0)) {
                throw new Error("Invalid configuration: mixed template components and items property.");
            }
        }
    }
    onItemAction(item) {
        if (!item) {
            return;
        }
        let modifiedItems = new Array();
        this.allItems
            .forEach((currentItem) => {
            let selectedState = currentItem === item;
            let focusedState = selectedState;
            selectedState = this.selectable ? selectedState : currentItem.selected;
            if (currentItem.selected !== selectedState || currentItem.focused !== focusedState) {
                currentItem.selected = selectedState;
                currentItem.focused = focusedState;
                this.activeDescendant = focusedState ? currentItem.itemId : "";
                modifiedItems.push(currentItem);
            }
        });
        if (this.expandMode === PanelBarExpandMode.Multiple) {
            if (item.hasChildItems || item.hasContent) {
                item.expanded = !item.expanded;
            }
            if (modifiedItems.indexOf(item) < 0) {
                modifiedItems.push(item);
            }
        }
        else {
            let siblings = item.parent ? item.parent.childrenItems : this.childrenItems;
            if (item.hasChildItems || item.hasContent) {
                siblings
                    .forEach((currentItem) => {
                    let expandedState = currentItem === item;
                    if (currentItem.expanded !== expandedState) {
                        currentItem.expanded = expandedState;
                        if (modifiedItems.indexOf(currentItem) < 0) {
                            modifiedItems.push(currentItem);
                        }
                    }
                });
            }
        }
        if (modifiedItems.length > 0) {
            this.stateChange.emit(modifiedItems.map(currentItem => currentItem.serialize()));
        }
    }
    get hostClasses() {
        return true;
    }
    isVisible(item) {
        const visibleItems = this.visibleItems();
        return visibleItems.some(i => i === item);
    }
    getVisibleParent(item) {
        const visibleItems = this.visibleItems();
        if (!item.parent) {
            return item;
        }
        return visibleItems.some(i => i === item.parent) ? item.parent : this.getVisibleParent(item.parent);
    }
    focusItem(action) {
        const visibleItems = this.visibleItems();
        let currentIndex = visibleItems.findIndex(item => item.focused);
        let currentItem = visibleItems[currentIndex];
        let nextItem;
        if (currentIndex === -1) {
            let focusedItem = this.allItems.find(item => item.focused);
            focusedItem.focused = false;
            currentItem = this.getVisibleParent(focusedItem);
            currentIndex = visibleItems.findIndex(item => item === currentItem);
        }
        switch (action) {
            case "lastItem":
                nextItem = visibleItems[visibleItems.length - 1];
                break;
            case "firstItem":
                nextItem = visibleItems[0];
                break;
            case "nextItem":
                nextItem = visibleItems[currentIndex < visibleItems.length - 1 ? currentIndex + 1 : 0];
                break;
            case "previousItem":
                nextItem = visibleItems[currentIndex > 0 ? currentIndex - 1 : visibleItems.length - 1];
                break;
            default:
        }
        if (currentItem && nextItem && currentItem !== nextItem) {
            this.moveFocus(currentItem, nextItem);
        }
    }
    moveFocus(from, to) {
        from.focused = false;
        to.focused = true;
        this.activeDescendant = to.itemId;
        const modifiedItems = new Array(from.serialize(), to.serialize());
        this.stateChange.emit(modifiedItems);
    }
    focusLastItem() {
        this.focusItem("lastItem");
    }
    focusFirstItem() {
        this.focusItem("firstItem");
    }
    focusNextItem() {
        this.focusItem("nextItem");
    }
    focusPreviousItem() {
        this.focusItem("previousItem");
    }
    expandItem() {
        let currentItem = this.allItems.filter(item => item.focused)[0];
        if (!this.isVisible(currentItem)) {
            currentItem.focused = false;
            currentItem = this.getVisibleParent(currentItem);
        }
        if (currentItem.hasChildItems || currentItem.hasContent) {
            if (!currentItem.expanded) {
                this.onItemAction(currentItem);
            }
            else if (currentItem.hasChildItems) {
                const firstChildIndex = currentItem.childrenItems.findIndex(item => !item.disabled);
                if (firstChildIndex > -1) {
                    this.moveFocus(currentItem, currentItem.childrenItems[firstChildIndex]);
                }
            }
        }
    }
    collapseItem() {
        const currentItem = this.allItems.filter(item => item.focused)[0];
        if (currentItem.expanded) {
            this.onItemAction(currentItem);
        }
        else if (currentItem.parent) {
            this.moveFocus(currentItem, currentItem.parent);
        }
    }
    selectFocusedItem() {
        let focusedItem = this.allItems.filter(item => item.focused)[0];
        if (!this.isVisible(focusedItem)) {
            focusedItem.focused = false;
            focusedItem = this.getVisibleParent(focusedItem);
        }
        if (focusedItem) {
            focusedItem.onItemAction();
        }
    }
    visibleItems() {
        return this.flatVisibleItems(this.childrenItems);
    }
    flatVisibleItems(listOfItems = new Array(), flattedItems = new Array()) {
        listOfItems.forEach(item => {
            if (!item.disabled) {
                flattedItems.push(item);
                if (item.expanded && item.hasChildItems) {
                    this.flatVisibleItems(item.childrenItems, flattedItems);
                }
            }
        });
        return flattedItems;
    }
}
PanelBarComponent.ɵfac = function PanelBarComponent_Factory(t) { return new (t || PanelBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(PanelBarService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
PanelBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PanelBarComponent, selectors: [["kendo-panelbar"]], contentQueries: function PanelBarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, PanelBarItemTemplateDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, PanelBarItemComponent, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, PanelBarItemComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentItems = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildItems = _t);
    } }, viewQuery: function PanelBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(PanelBarItemComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.viewChildItems = _t);
    } }, hostVars: 12, hostBindings: function PanelBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function PanelBarComponent_click_HostBindingHandler($event) { return ctx.onComponentClick($event); })("focus", function PanelBarComponent_focus_HostBindingHandler() { return ctx.onComponentFocus(); })("blur", function PanelBarComponent_blur_HostBindingHandler() { return ctx.onComponentBlur(); })("keydown", function PanelBarComponent_keydown_HostBindingHandler($event) { return ctx.onComponentKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabIndex", ctx.tabIndex)("role", ctx.role)("aria-activedescendant", ctx.activeDescendant)("dir", ctx.dir);
        ɵngcc0.ɵɵstyleProp("height", ctx.hostHeight)("overflow", ctx.overflow);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-panelbar", ctx.hostClasses);
    } }, inputs: { expandMode: "expandMode", selectable: "selectable", animate: "animate", height: "height", keepItemContent: "keepItemContent", items: "items" }, outputs: { stateChange: "stateChange" }, exportAs: ["kendoPanelbar"], features: [ɵngcc0.ɵɵProvidersFeature([
            PanelBarService,
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.panelbar'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "ngIf"], [4, "ngFor", "ngForOf"], [3, "title", "id", "icon", "iconClass", "imageUrl", "selected", "expanded", "disabled", "template", "items", "content", 4, "ngIf"], [3, "title", "id", "icon", "iconClass", "imageUrl", "selected", "expanded", "disabled", "template", "items", "content"]], template: function PanelBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵtemplate(0, PanelBarComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
        ɵngcc0.ɵɵtemplate(1, PanelBarComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.contentChildItems && !ctx.items);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.items == null ? null : ctx.items.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, PanelBarItemComponent], encapsulation: 2 });
/** @nocollapse */
PanelBarComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: PanelBarService },
    { type: LocalizationService }
];
PanelBarComponent.propDecorators = {
    expandMode: [{ type: Input }],
    selectable: [{ type: Input }],
    animate: [{ type: Input }],
    height: [{ type: Input }],
    keepItemContent: [{ type: Input }],
    items: [{ type: Input }],
    stateChange: [{ type: Output }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabIndex',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    activeDescendant: [{ type: HostBinding, args: ['attr.aria-activedescendant',] }],
    hostHeight: [{ type: HostBinding, args: ['style.height',] }],
    overflow: [{ type: HostBinding, args: ['style.overflow',] }],
    dir: [{ type: HostBinding, args: ['attr.dir',] }],
    template: [{ type: ContentChild, args: [PanelBarItemTemplateDirective,] }],
    contentItems: [{ type: ContentChildren, args: [PanelBarItemComponent, { descendants: true },] }],
    contentChildItems: [{ type: ContentChildren, args: [PanelBarItemComponent,] }],
    viewChildItems: [{ type: ViewChildren, args: [PanelBarItemComponent,] }],
    onComponentClick: [{ type: HostListener, args: ['click', ['$event'],] }],
    onComponentFocus: [{ type: HostListener, args: ['focus',] }],
    onComponentBlur: [{ type: HostListener, args: ['blur',] }],
    onComponentKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-panelbar',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoPanelbar',
                providers: [
                    PanelBarService,
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.panelbar'
                    }
                ],
                selector: 'kendo-panelbar',
                template: `
        <ng-content *ngIf="contentChildItems && !items" select="kendo-panelbar-item"></ng-content>
        <ng-template [ngIf]="items?.length">
            <ng-container *ngFor="let item of items">
                <kendo-panelbar-item *ngIf="!item.hidden"
                     [title]="item.title"
                     [id]="item.id"
                     [icon]="item.icon"
                     [iconClass]="item.iconClass"
                     [imageUrl]="item.imageUrl"
                     [selected]="!!item.selected"
                     [expanded]="!!item.expanded"
                     [disabled]="!!item.disabled"
                     [template]="templateRef"
                     [items]="item.children"
                     [content]="item.content"
                >
                </kendo-panelbar-item>
            </ng-container>
        </ng-template>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: PanelBarService }, { type: ɵngcc2.LocalizationService }]; }, { expandMode: [{
            type: Input
        }], selectable: [{
            type: Input
        }], animate: [{
            type: Input
        }], height: [{
            type: Input
        }], stateChange: [{
            type: Output
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabIndex']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], activeDescendant: [{
            type: HostBinding,
            args: ['attr.aria-activedescendant']
        }], keepItemContent: [{
            type: Input
        }], items: [{
            type: Input
        }], hostHeight: [{
            type: HostBinding,
            args: ['style.height']
        }], overflow: [{
            type: HostBinding,
            args: ['style.overflow']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], 
    /**
     * @hidden
     */
    onComponentClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], 
    /**
     * @hidden
     */
    onComponentFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /**
     * @hidden
     */
    onComponentBlur: [{
            type: HostListener,
            args: ['blur']
        }], 
    /**
     * @hidden
     */
    onComponentKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-panelbar']
        }], template: [{
            type: ContentChild,
            args: [PanelBarItemTemplateDirective]
        }], contentItems: [{
            type: ContentChildren,
            args: [PanelBarItemComponent, { descendants: true }]
        }], contentChildItems: [{
            type: ContentChildren,
            args: [PanelBarItemComponent]
        }], viewChildItems: [{
            type: ViewChildren,
            args: [PanelBarItemComponent]
        }] }); })();

/**
 * Represents the pane component of the Splitter.
 */
class SplitterPaneComponent {
    constructor(element, renderer, cdr) {
        this.element = element;
        this.renderer = renderer;
        this.cdr = cdr;
        /**
         * Specifies if the user is allowed to resize the pane and provide space for other panes.
         */
        this.resizable = true;
        /**
         * Specifies if the user is allowed to hide the pane and provide space for other panes.
         */
        this.collapsible = false;
        /**
         * Specifies if overflowing content is scrollable or hidden.
         */
        this.scrollable = true;
        /**
         * Specifies if the pane is initially collapsed.
         */
        this.collapsed = false;
        /**
         * @hidden
         */
        this.orientation = 'horizontal';
        /**
         * @hidden
         */
        this.containsSplitter = false;
        /**
         * @hidden
         */
        this.overlayContent = false;
        /**
         * Fires each time the user resizes the Splitter pane.
         * The event data contains the new pane size.
         * Allows a two-way binding of the pane `size` property.
         */
        this.sizeChange = new EventEmitter();
        /**
         * Fires each time the `collapsed` property changes.
         * The event data contains the new property state.
         * Allows a two-way binding of the `collapsed` pane property.
         */
        this.collapsedChange = new EventEmitter();
        this.hostClass = true;
        /**
         * @hidden
         */
        this.forceExpand = false;
    }
    /**
     * @hidden
     */
    set order(paneOrder) {
        this._order = paneOrder;
        this.setOrderStyles();
    }
    get order() {
        return this._order;
    }
    /**
     * Sets the initial size of the pane.
     * Has to be between the `min` and `max` properties.
     */
    set size(newSize) {
        this._size = newSize;
        const element = this.element.nativeElement;
        this.renderer.setStyle(element, '-ms-flex-preferred-size', newSize);
        this.renderer.setStyle(element, 'flex-basis', newSize);
        if (this.staticPaneClass) {
            this.renderer.addClass(element, 'k-pane-static');
        }
        else {
            this.renderer.removeClass(element, 'k-pane-static');
        }
    }
    get size() {
        return this._size;
    }
    get isHidden() {
        return this.collapsed;
    }
    get styleDisplayFlex() {
        return this.containsSplitter;
    }
    get staticPaneClass() {
        if (this.forceExpand) {
            return false;
        }
        return !this.resizable && !this.collapsible || this.fixedSize;
    }
    get scrollablePaneClass() {
        return this.scrollable;
    }
    get fixedSize() {
        return this.size && this.size.length > 0;
    }
    ngAfterViewChecked() {
        const element = this.element.nativeElement;
        if (this.isHidden) {
            this.renderer.addClass(element, 'k-state-hidden');
            this.renderer.addClass(element, 'hidden');
        }
        else {
            this.renderer.removeClass(element, 'k-state-hidden');
            this.renderer.removeClass(element, 'hidden');
        }
    }
    /**
     * @hidden
     */
    get computedSize() {
        if (this.orientation === 'vertical') {
            return this.element.nativeElement.offsetHeight;
        }
        else {
            return this.element.nativeElement.offsetWidth;
        }
    }
    /**
     * @hidden
     */
    toggleOverlay(show) {
        this.overlayContent = show;
        this.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    detectChanges() {
        this.cdr.detectChanges();
    }
    /**
     * @hidden
     */
    setOrderStyles() {
        const element = this.element.nativeElement;
        this.renderer.setStyle(element, '-ms-flex-order', this.order);
        this.renderer.setStyle(element, 'order', this.order);
    }
}
SplitterPaneComponent.ɵfac = function SplitterPaneComponent_Factory(t) { return new (t || SplitterPaneComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SplitterPaneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SplitterPaneComponent, selectors: [["kendo-splitter-pane"]], hostVars: 8, hostBindings: function SplitterPaneComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-pane", ctx.hostClass)("k-pane-flex", ctx.styleDisplayFlex)("k-pane-static", ctx.staticPaneClass)("k-scrollable", ctx.scrollablePaneClass);
    } }, inputs: { resizable: "resizable", collapsible: "collapsible", scrollable: "scrollable", collapsed: "collapsed", orientation: "orientation", containsSplitter: "containsSplitter", overlayContent: "overlayContent", order: "order", size: "size", min: "min", max: "max" }, outputs: { sizeChange: "sizeChange", collapsedChange: "collapsedChange" }, exportAs: ["kendoSplitterPane"], ngContentSelectors: _c6, decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "k-splitter-overlay k-overlay", 4, "ngIf"], [1, "k-splitter-overlay", "k-overlay"]], template: function SplitterPaneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, SplitterPaneComponent_ng_container_0_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, SplitterPaneComponent_div_1_Template, 1, 0, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.collapsed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.overlayContent);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
/** @nocollapse */
SplitterPaneComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
SplitterPaneComponent.propDecorators = {
    order: [{ type: Input }],
    size: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    resizable: [{ type: Input }],
    collapsible: [{ type: Input }],
    scrollable: [{ type: Input }],
    collapsed: [{ type: Input }],
    orientation: [{ type: Input }],
    containsSplitter: [{ type: Input }],
    overlayContent: [{ type: Input }],
    sizeChange: [{ type: Output }],
    collapsedChange: [{ type: Output }],
    styleDisplayFlex: [{ type: HostBinding, args: ['class.k-pane-flex',] }],
    hostClass: [{ type: HostBinding, args: ['class.k-pane',] }],
    staticPaneClass: [{ type: HostBinding, args: ['class.k-pane-static',] }],
    scrollablePaneClass: [{ type: HostBinding, args: ['class.k-scrollable',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SplitterPaneComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoSplitterPane',
                selector: 'kendo-splitter-pane',
                template: `
        <ng-container *ngIf="!collapsed"><ng-content></ng-content></ng-container>
        <div *ngIf="overlayContent" class="k-splitter-overlay k-overlay"></div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { resizable: [{
            type: Input
        }], collapsible: [{
            type: Input
        }], scrollable: [{
            type: Input
        }], collapsed: [{
            type: Input
        }], orientation: [{
            type: Input
        }], containsSplitter: [{
            type: Input
        }], overlayContent: [{
            type: Input
        }], sizeChange: [{
            type: Output
        }], collapsedChange: [{
            type: Output
        }], hostClass: [{
            type: HostBinding,
            args: ['class.k-pane']
        }], order: [{
            type: Input
        }], size: [{
            type: Input
        }], styleDisplayFlex: [{
            type: HostBinding,
            args: ['class.k-pane-flex']
        }], staticPaneClass: [{
            type: HostBinding,
            args: ['class.k-pane-static']
        }], scrollablePaneClass: [{
            type: HostBinding,
            args: ['class.k-scrollable']
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }] }); })();

const SIZING_DOC_LINK = 'https://www.telerik.com/kendo-angular-ui/components/layout/splitter/panes/#toc-size';
/**
 * @hidden
 */
class SplitterService {
    constructor(zone) {
        this.zone = zone;
        this.layoutChange = new EventEmitter();
        this.containerSize = () => { };
    }
    tryToggle(paneIndex) {
        const pane = this.pane(paneIndex);
        if (pane.collapsible) {
            pane.collapsed = !pane.collapsed;
            pane.collapsedChange.emit(pane.collapsed);
            this.emit(this.layoutChange, {});
            if (pane.collapsed) {
                pane.detectChanges();
            }
        }
        const notCollapsed = this.panes.filter(p => !p.collapsed);
        const allHaveFixedSize = notCollapsed.every(p => p.fixedSize);
        notCollapsed[notCollapsed.length - 1].forceExpand = allHaveFixedSize ? true : false;
        return pane.collapsible;
    }
    toggleContentOverlay(index, show) {
        this.pane(index).toggleOverlay(show);
        this.pane(index + 1).toggleOverlay(show);
    }
    dragState(splitbarIndex) {
        let prev = this.pane(splitbarIndex);
        let next = this.pane(splitbarIndex + 1);
        const total = prev.computedSize + next.computedSize;
        const px = s => this.toPixels(s);
        return {
            prev: {
                index: splitbarIndex,
                initialSize: prev.computedSize,
                min: px(prev.min) || total - px(next.max) || 0,
                max: px(prev.max) || total - px(next.min) || total
            },
            next: {
                index: splitbarIndex + 1,
                initialSize: next.computedSize,
                min: px(next.min) || total - px(prev.max) || 0,
                max: px(next.max) || total - px(prev.min) || total
            }
        };
    }
    setSize(state$$1, delta) {
        const clamp = (min, max, v) => Math.min(max, Math.max(min, v));
        const resize = (paneState, change) => {
            const pane = this.pane(paneState.index);
            const splitterSize = this.containerSize();
            const newSize = clamp(paneState.min, paneState.max, paneState.initialSize + change);
            let size = "";
            if (this.isPercent(pane.size)) {
                size = (100 * newSize / splitterSize) + "%";
            }
            else {
                size = newSize + "px";
            }
            pane.size = size;
            this.emit(pane.sizeChange, size);
        };
        const prev = this.pane(state$$1.prev.index);
        const next = this.pane(state$$1.next.index);
        // determine which pane to resize
        if (prev.fixedSize && next.fixedSize) {
            // resizing both panes
            resize(state$$1.prev, delta);
            resize(state$$1.next, -delta);
        }
        else if (next.collapsible || next.fixedSize) {
            // resizing next
            resize(state$$1.next, -delta);
        }
        else {
            // resizing prev
            resize(state$$1.prev, delta);
        }
        this.emit(this.layoutChange, {});
    }
    isDraggable(splitBarIndex) {
        const prev = this.pane(splitBarIndex);
        const next = this.pane(splitBarIndex + 1);
        const betweenResizablePanes = prev.resizable && next.resizable;
        const nearCollapsedPane = prev.collapsed || next.collapsed;
        return betweenResizablePanes && !nearCollapsedPane;
    }
    isStatic(splitBarIndex) {
        const prev = this.pane(splitBarIndex);
        const next = this.pane(splitBarIndex + 1);
        const betweenResizablePanes = prev.resizable && next.resizable;
        const nearCollapsiblePane = prev.collapsible || next.collapsible;
        return !betweenResizablePanes && !nearCollapsiblePane;
    }
    pane(index) {
        if (!this.panes) {
            throw new Error("Panes not initialized");
        }
        if (index < 0 || index >= this.panes.length) {
            throw new Error("Index out of range");
        }
        return this.panes[index];
    }
    configure({ panes, orientation, containerSize }) {
        this.panes = panes;
        this.panes.forEach((pane, index) => {
            pane.order = index * 2;
            pane.orientation = orientation;
        });
        if (isDevMode()) {
            const allFixed = panes.length && !panes.some(pane => !pane.fixedSize);
            if (allFixed) {
                throw new Error(`
                    The Splitter should have at least one pane without a set size.
                    See ${SIZING_DOC_LINK} for more information.
                `);
            }
        }
        this.containerSize = containerSize;
    }
    isPercent(size) {
        return /%$/.test(size);
    }
    toPixels(size) {
        let result = parseFloat(size);
        if (this.isPercent(size)) {
            result = (this.containerSize() * result / 100);
        }
        return result;
    }
    emit(emitter, args) {
        if (emitter.observers.length) {
            this.zone.run(() => emitter.emit(args));
        }
    }
}
SplitterService.ɵfac = function SplitterService_Factory(t) { return new (t || SplitterService)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
SplitterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SplitterService, factory: SplitterService.ɵfac });
/** @nocollapse */
SplitterService.ctorParameters = () => [
    { type: NgZone }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SplitterService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, null); })();

/**
 * Represents the [Kendo UI Splitter component for Angular]({% slug overview_splitter %}).
 *
 * ```ts-preview
 *
 *  @Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-splitter style="height: 280px;">
 *
 *          <kendo-splitter-pane [collapsible]="true" size="30%">
 *            <h3>Inner splitter / left pane</h3>
 *            <p>Resizable and collapsible.</p>
 *          </kendo-splitter-pane>
 *
 *          <kendo-splitter-pane>
 *            <h3>Inner splitter / center pane</h3>
 *            <p>Resizable only.</p>
 *          </kendo-splitter-pane>
 *
 *          <kendo-splitter-pane [collapsible]="true" size="30%">
 *            <h3>Inner splitter / right pane</h3>
 *            <p>Resizable and collapsible.</p>
 *          </kendo-splitter-pane>
 *
 *        </kendo-splitter>
 *      `,
 *    styles: [ `
 *        h3 { font-size: 1.2em; }
 *        h3, p { margin: 10px; padding: 0; }
 *    ` ]
 *  })
 *  class AppComponent {}
 * ```
 */
class SplitterComponent {
    constructor(element, splitterService, localization, enclosingPane) {
        this.element = element;
        this.splitterService = splitterService;
        this.localization = localization;
        /**
         * Specifies the orientation of the panes within the Splitter.
         * Panes in a horizontal Splitter are placed horizontally.
         * Panes in a vertical Splitter are placed vertically.
         */
        this.orientation = 'horizontal';
        this.ariaRole = 'splitter';
        if (enclosingPane) {
            enclosingPane.containsSplitter = true;
        }
        // the handler only runs in NgZone if there are bound handlers
        // this line merges both streams
        this.layoutChange = this.splitterService.layoutChange;
        this.configure = this.configure.bind(this);
    }
    get hostClasses() {
        return true;
    }
    get horizontalHostClasses() {
        return this.orientation === 'horizontal';
    }
    get verticalHostClasses() {
        return this.orientation === 'vertical';
    }
    get dir() {
        return this.direction;
    }
    ngAfterContentInit() {
        this.reconfigure();
    }
    ngOnChanges(changes) {
        if (changes.orientation && !changes.orientation.isFirstChange()) {
            this.reconfigure();
        }
    }
    ngOnDestroy() {
        this.unsubscribeChanges();
    }
    reconfigure() {
        this.unsubscribeChanges();
        this.configure();
        this.paneChangesSubscription = this.panes.changes.subscribe(this.configure);
    }
    unsubscribeChanges() {
        if (this.paneChangesSubscription) {
            this.paneChangesSubscription.unsubscribe();
            this.paneChangesSubscription = null;
        }
    }
    configure() {
        this.splitterService.configure({
            panes: this.panes.toArray(),
            orientation: this.orientation,
            containerSize: () => {
                if (this.orientation === 'vertical') {
                    return this.element.nativeElement.clientHeight;
                }
                else {
                    return this.element.nativeElement.clientWidth;
                }
            }
        });
    }
    get direction() {
        return this.localization.rtl ? 'rtl' : 'ltr';
    }
}
SplitterComponent.ɵfac = function SplitterComponent_Factory(t) { return new (t || SplitterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(SplitterService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(SplitterPaneComponent, 9)); };
SplitterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SplitterComponent, selectors: [["kendo-splitter"]], contentQueries: function SplitterComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SplitterPaneComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panes = _t);
    } }, hostVars: 12, hostBindings: function SplitterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.ariaRole)("dir", ctx.dir);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-splitter", ctx.hostClasses)("k-splitter-flex", ctx.hostClasses)("k-splitter-horizontal", ctx.horizontalHostClasses)("k-splitter-vertical", ctx.verticalHostClasses);
    } }, inputs: { orientation: "orientation" }, outputs: { layoutChange: "layoutChange" }, exportAs: ["kendoSplitter"], features: [ɵngcc0.ɵɵProvidersFeature([
            SplitterService,
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.spliter'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c8, decls: 2, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["kendoDraggable", "", 3, "index", "orientation", 4, "ngIf"], ["kendoDraggable", "", 3, "index", "orientation"]], template: function SplitterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, SplitterComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.panes);
    } }, directives: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, SplitterBarComponent, ɵngcc3.DraggableDirective]; }, encapsulation: 2 });
/** @nocollapse */
SplitterComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: SplitterService },
    { type: LocalizationService },
    { type: SplitterPaneComponent, decorators: [{ type: Optional }, { type: Host }, { type: Inject, args: [SplitterPaneComponent,] }] }
];
SplitterComponent.propDecorators = {
    orientation: [{ type: Input }],
    layoutChange: [{ type: Output }],
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-splitter',] }, { type: HostBinding, args: ['class.k-splitter-flex',] }],
    horizontalHostClasses: [{ type: HostBinding, args: ['class.k-splitter-horizontal',] }],
    verticalHostClasses: [{ type: HostBinding, args: ['class.k-splitter-vertical',] }],
    dir: [{ type: HostBinding, args: ['attr.dir',] }],
    ariaRole: [{ type: HostBinding, args: ['attr.role',] }],
    panes: [{ type: ContentChildren, args: [SplitterPaneComponent,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SplitterComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoSplitter',
                selector: 'kendo-splitter',
                providers: [
                    SplitterService,
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.spliter'
                    }
                ],
                template: `
      <ng-content select="kendo-splitter-pane"></ng-content>
      <ng-container *ngFor="
        let pane of panes;
        let index = index;
        let last = last;
      ">
        <kendo-splitter-bar
          kendoDraggable
          *ngIf="!last"
          [index]="index"
          [orientation]="orientation">
        </kendo-splitter-bar>
      </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: SplitterService }, { type: ɵngcc2.LocalizationService }, { type: SplitterPaneComponent, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: Inject,
                args: [SplitterPaneComponent]
            }] }]; }, { orientation: [{
            type: Input
        }], ariaRole: [{
            type: HostBinding,
            args: ['attr.role']
        }], layoutChange: [{
            type: Output
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-splitter']
        }, {
            type: HostBinding,
            args: ['class.k-splitter-flex']
        }], horizontalHostClasses: [{
            type: HostBinding,
            args: ['class.k-splitter-horizontal']
        }], verticalHostClasses: [{
            type: HostBinding,
            args: ['class.k-splitter-vertical']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], panes: [{
            type: ContentChildren,
            args: [SplitterPaneComponent]
        }] }); })();

/**
 * Represents the content template of the Kendo UI TabStrip.
 * To define the template, nest a `<ng-template>` tag with the `kendoTabContent` inside the component tag.
 *
 * @example
 * ```ts-preview
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *         <kendo-tabstrip [ngStyle]="{'width': '400px'}" [animate]="true">
 *           <kendo-tabstrip-tab [title]="'Paris'" [selected]="true">
 *             <ng-template kendoTabContent>
 *               <h3>Content 1</h3>
 *             </ng-template>
 *           </kendo-tabstrip-tab>
 *
 *           <kendo-tabstrip-tab [title]="'Sofia'">
 *             <ng-template kendoTabContent>
 *               <h3>Content 2</h3>
 *             </ng-template>
 *           </kendo-tabstrip-tab>
 *         </kendo-tabstrip>
 *     `
 * })
 *
 * class AppComponent {}
 *
 * ```
 */
class TabContentDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TabContentDirective.ɵfac = function TabContentDirective_Factory(t) { return new (t || TabContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TabContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TabContentDirective, selectors: [["", "kendoTabContent", ""]] });
/** @nocollapse */
TabContentDirective.ctorParameters = () => [
    { type: TemplateRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabContentDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoTabContent]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

/**
 * Represents the title template of the Kendo UI TabStrip.
 * To define the template, nest a `<ng-template>` tag with the `kendoTabTitle` directive inside the component tag.
 *
 * @example
 * ```ts-preview
 *
 * _@Component({
 *     selector: 'my-app',
 *     template: `
 *         <kendo-tabstrip [ngStyle]="{'width': '400px'}" [animate]="true">
 *           <kendo-tabstrip-tab [title]="'Paris'" [selected]="true">
 *             <ng-template kendoTabTitle>
 *               Title
 *             </ng-template>
 *             <ng-template kendoTabContent>
 *               <h3>Content 1</h3>
 *             </ng-template>
 *           </kendo-tabstrip-tab>
 *
 *           <kendo-tabstrip-tab [title]="'Sofia'">
 *             <ng-template kendoTabContent>
 *               <h3>Content 2</h3>
 *             </ng-template>
 *           </kendo-tabstrip-tab>
 *         </kendo-tabstrip>
 *     `
 * })
 *
 * class AppComponent {}
 *
 * ```
 */
class TabTitleDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TabTitleDirective.ɵfac = function TabTitleDirective_Factory(t) { return new (t || TabTitleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TabTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TabTitleDirective, selectors: [["", "kendoTabTitle", ""]] });
/** @nocollapse */
TabTitleDirective.ctorParameters = () => [
    { type: TemplateRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoTabTitle]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

/**
 * Represents the tab component of the TabStrip.
 */
class TabStripTabComponent {
    constructor() {
        this.active = false;
        this._tabContent = new QueryList();
    }
    get tabContent() {
        return this._tabContent.first;
    }
    ngAfterContentInit() {
        this.active = this.selected;
    }
    ngOnChanges(changes) {
        if (changes['selected'] && !changes['selected'].isFirstChange()) { // tslint:disable-line
            this.active = this.selected;
        }
    }
}
TabStripTabComponent.ɵfac = function TabStripTabComponent_Factory(t) { return new (t || TabStripTabComponent)(); };
TabStripTabComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabStripTabComponent, selectors: [["kendo-tabstrip-tab"]], contentQueries: function TabStripTabComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabTitleDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabContentDirective, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabTitle = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._tabContent = _t);
    } }, inputs: { title: "title", disabled: "disabled", cssClass: "cssClass", selected: "selected" }, exportAs: ["kendoTabStripTab"], features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function TabStripTabComponent_Template(rf, ctx) { }, encapsulation: 2 });
TabStripTabComponent.propDecorators = {
    title: [{ type: Input }],
    disabled: [{ type: Input }],
    cssClass: [{ type: Input }],
    selected: [{ type: Input }],
    _tabContent: [{ type: ContentChildren, args: [TabContentDirective,] }],
    tabTitle: [{ type: ContentChild, args: [TabTitleDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabStripTabComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoTabStripTab',
                selector: 'kendo-tabstrip-tab',
                template: ``
            }]
    }], function () { return []; }, { _tabContent: [{
            type: ContentChildren,
            args: [TabContentDirective]
        }], title: [{
            type: Input
        }], disabled: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], selected: [{
            type: Input
        }], tabTitle: [{
            type: ContentChild,
            args: [TabTitleDirective]
        }] }); })();

/**
 * @hidden
 */
class PreventableEvent {
    /**
     * @hidden
     */
    constructor(args) {
        this.prevented = false;
        Object.assign(this, args);
    }
    /**
     * Prevents the default action for a specified event.
     * In this way, the source component suppresses
     * the built-in behavior that follows the event.
     */
    preventDefault() {
        this.prevented = true;
    }
    /**
     * Returns `true` if the event was prevented
     * by any of its subscribers.
     *
     * @returns `true` if the default action was prevented.
     * Otherwise, returns `false`.
     */
    isDefaultPrevented() {
        return this.prevented;
    }
}

/**
 * Arguments for the `select` event of the TabStrip.
 * The `select` event fires when a tab is selected (clicked).
 */
class SelectEvent extends PreventableEvent {
    /**
     * Constructs the event arguments for the `select` event.
     * @param index - The index of the selected tab.
     * @param title - The title of the selected tab.
     */
    constructor(index, title) {
        super();
        this.index = index;
        this.title = title;
    }
}

/**
 * Represents the [Kendo UI TabStrip component for Angular]({% slug overview_tabstrip %}).
 */
class TabStripComponent {
    constructor(localization, renderer, wrapper) {
        this.localization = localization;
        this.renderer = renderer;
        this.wrapper = wrapper;
        /**
         * Enables the tab animation.
         */
        this.animate = true;
        /**
         * Sets the position of the tabs. Defaults to `top`.
         */
        this.tabPosition = 'top';
        /**
         * When set to `true`, the component renders all tabs and they are persisted in the DOM.
         * By default, `keepTabContent` is `false`.
         */
        this.keepTabContent = false;
        /**
         * Fires each time the user selects a tab ([see example]({% slug overview_tabstrip %}#toc-basic-usage)).
         * The event data contains the index of the selected tab and its title.
         */
        this.tabSelect = new EventEmitter();
        this.hostClasses = true;
        /**
         * @hidden
         */
        this._animate = false;
        this.keyBindings = this.computedKeys;
    }
    /**
     * Sets the height of the TabStrip.
     */
    set height(value) {
        this._height = value;
        this.renderer.setStyle(this.wrapper.nativeElement, 'height', value);
    }
    get height() {
        return this._height;
    }
    get tabsAtTop() {
        return this.tabPosition === 'top';
    }
    get tabsAtRight() {
        return this.tabPosition === 'right';
    }
    get tabsAtBottom() {
        return this.tabPosition === 'bottom';
    }
    get tabsAtLeft() {
        return this.tabPosition === 'left';
    }
    get dir() {
        return this.localization.rtl ? 'rtl' : 'ltr';
    }
    /**
     * @hidden
     */
    contentClass(active) {
        const visible = !this.keepTabContent || active;
        return visible ? 'k-content k-state-active' : 'k-content';
    }
    get computedKeys() {
        return {
            [this.invertKeys(Keys.ArrowLeft, Keys.ArrowRight)]: (selectedIndex) => this.prevNavigatableIndex(selectedIndex),
            [this.invertKeys(Keys.ArrowRight, Keys.ArrowLeft)]: (selectedIndex) => this.nextNavigatableIndex(selectedIndex),
            [this.invertKeys(Keys.ArrowDown, Keys.ArrowUp)]: (selectedIndex) => this.nextNavigatableIndex(selectedIndex),
            [this.invertKeys(Keys.ArrowUp, Keys.ArrowDown)]: (selectedIndex) => this.prevNavigatableIndex(selectedIndex),
            [Keys.Home]: () => this.firstNavigatableIndex(),
            [Keys.End]: () => this.lastNavigatableIndex()
        };
    }
    /**
     * @hidden
     */
    get tabsAlignment() {
        return {
            start: 'flex-start',
            end: 'flex-end',
            center: 'center',
            justify: 'space-between'
        }[this.tabAlignment];
    }
    /**
     * @hidden
     */
    invertKeys(original, inverted) {
        return this.localization.rtl ? inverted : original;
    }
    /**
     * @hidden
     */
    onKeyDown(event) {
        if (event.currentTarget !== this.tablist.nativeElement) {
            return;
        }
        const isHorizontal = this.tabPosition === 'top' || this.tabPosition === 'bottom';
        const isArrowUp = event.keyCode === Keys.ArrowUp;
        const isArrowDown = event.keyCode === Keys.ArrowDown;
        const isArrowLeft = event.keyCode === Keys.ArrowLeft;
        const isArrowRight = event.keyCode === Keys.ArrowRight;
        if (isHorizontal && (isArrowUp || isArrowDown)) {
            return;
        }
        if (!isHorizontal && (isArrowLeft || isArrowRight)) {
            return;
        }
        if (event.keyCode === Keys.Space || isArrowUp || isArrowDown || isArrowLeft || isArrowRight || event.keyCode === Keys.Home ||
            event.keyCode === Keys.End || event.keyCode === Keys.PageUp || event.keyCode === Keys.PageDown) {
            event.preventDefault();
        }
        const selectedIndex = this.tabs.toArray().findIndex(tab => tab.active && !tab.disabled);
        if (selectedIndex === -1) {
            this.selectTab(this.firstNavigatableIndex());
        }
        else {
            const getTabIndex = this.keyBindings[event.keyCode];
            if (getTabIndex) {
                const nextIndex = getTabIndex(selectedIndex);
                if (selectedIndex !== nextIndex) {
                    this.selectTab(getTabIndex(selectedIndex));
                }
            }
        }
    }
    /**
     * @hidden
     */
    tabPanelId(id) {
        return 'k-tabstrip-tabpanel-' + id;
    }
    /**
     * @hidden
     */
    tabId(id) {
        return 'k-tabstrip-tab-' + id;
    }
    /**
     * Allows the user to select a tab programmatically.
     * @param {number} index - The index of the tab that will be selected.
     */
    selectTab(index) {
        const tab = this.tabs.toArray()[index];
        if (!tab || Boolean(tab.disabled)) {
            return;
        }
        this.tabHeadingContainers.toArray()[index].nativeElement.focus();
        this.emitEvent(tab, index);
    }
    /**
     * @hidden
     */
    onTabClick(originalEvent, tabIndex) {
        if (isFocusable(originalEvent.target)) {
            return;
        }
        this.selectTab(tabIndex);
    }
    ngOnInit() {
        this.localizationChangeSubscription = this.localization
            .changes.subscribe(() => this.keyBindings = this.computedKeys);
    }
    ngOnDestroy() {
        if (this.localizationChangeSubscription) {
            this.localizationChangeSubscription.unsubscribe();
        }
    }
    firstNavigatableIndex() {
        const tabs = this.tabs.toArray();
        for (let i = 0; i < tabs.length; i++) {
            if (!tabs[i].disabled) {
                return i;
            }
        }
    }
    lastNavigatableIndex() {
        const tabs = this.tabs.toArray();
        for (let i = tabs.length - 1; i > 0; i--) {
            if (!tabs[i].disabled) {
                return i;
            }
        }
    }
    prevNavigatableIndex(selectedIndex) {
        if (selectedIndex - 1 < 0) {
            return this.lastNavigatableIndex();
        }
        const tabs = this.tabs.toArray();
        for (let i = selectedIndex - 1; i > -1; i--) {
            if (!tabs[i].disabled) {
                return i;
            }
            if (i === 0) {
                return this.lastNavigatableIndex();
            }
        }
        return selectedIndex;
    }
    nextNavigatableIndex(selectedIndex) {
        if (selectedIndex + 1 >= this.tabs.length) {
            return this.firstNavigatableIndex();
        }
        const tabs = this.tabs.toArray();
        for (let i = selectedIndex + 1; i < tabs.length; i++) {
            if (!tabs[i].disabled) {
                return i;
            }
            if (i + 1 === tabs.length) {
                return this.firstNavigatableIndex();
            }
        }
    }
    emitEvent(tab, selectedIndex) {
        const selectArgs = new SelectEvent(selectedIndex, tab.title);
        this.tabSelect.emit(selectArgs);
        if (!selectArgs.isDefaultPrevented() && !tab.active) {
            this._animate = this.animate;
            this.deactivateAll();
            tab.active = true;
        }
    }
    deactivateAll() {
        this.tabs.forEach((tab) => {
            tab.active = false;
        });
    }
}
TabStripComponent.ɵfac = function TabStripComponent_Factory(t) { return new (t || TabStripComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TabStripComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabStripComponent, selectors: [["kendo-tabstrip"]], contentQueries: function TabStripComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabStripTabComponent, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t);
    } }, viewQuery: function TabStripComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, true);
        ɵngcc0.ɵɵviewQuery(_c10, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tablist = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabHeadingContainers = _t);
    } }, hostVars: 17, hostBindings: function TabStripComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.dir);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-tabstrip", ctx.hostClasses)("k-floatwrap", ctx.hostClasses)("k-header", ctx.hostClasses)("k-tabstrip-top", ctx.tabsAtTop)("k-tabstrip-right", ctx.tabsAtRight)("k-tabstrip-bottom", ctx.tabsAtBottom)("k-tabstrip-left", ctx.tabsAtLeft);
    } }, inputs: { animate: "animate", tabPosition: "tabPosition", keepTabContent: "keepTabContent", height: "height", tabAlignment: "tabAlignment" }, outputs: { tabSelect: "tabSelect" }, exportAs: ["kendoTabStrip"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.tabstrip'
            }
        ])], decls: 6, vars: 2, consts: [[4, "ngIf"], ["heading", ""], ["content", ""], [4, "ngTemplateOutlet"], ["role", "tablist", 1, "k-reset", "k-tabstrip-items", 3, "keydown"], ["tablist", ""], ["role", "tab", 3, "id", "tabIndex", "ngClass", "k-item", "k-state-default", "k-state-active", "k-state-disabled", "click", 4, "ngFor", "ngForOf"], ["role", "tab", 3, "id", "tabIndex", "ngClass", "click"], ["tabHeadingContainer", ""], [1, "k-link"], [3, "ngTemplateOutlet"], ["ngFor", "", 3, "ngForOf"], ["role", "tabpanel", 3, "ngClass", "tabIndex", "id", 4, "ngIf"], ["role", "tabpanel", 3, "ngClass", "tabIndex", "id"]], template: function TabStripComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TabStripComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TabStripComponent_ng_container_1_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, TabStripComponent_ng_template_2_Template, 3, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, TabStripComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.tabsAtBottom);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tabsAtBottom);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, ɵngcc1.NgClass], encapsulation: 2, data: { animation: [
            trigger('state', [
                state('active', style({ opacity: 1 })),
                transition('* => active', [
                    style({ opacity: 0 }),
                    animate('400ms ease-in')
                ])
            ])
        ] } });
/** @nocollapse */
TabStripComponent.ctorParameters = () => [
    { type: LocalizationService },
    { type: Renderer2 },
    { type: ElementRef }
];
TabStripComponent.propDecorators = {
    height: [{ type: Input }],
    animate: [{ type: Input }],
    tabAlignment: [{ type: Input }],
    tabPosition: [{ type: Input }],
    keepTabContent: [{ type: Input }],
    tablist: [{ type: ViewChild, args: ['tablist',] }],
    tabSelect: [{ type: Output }],
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-tabstrip',] }, { type: HostBinding, args: ['class.k-floatwrap',] }, { type: HostBinding, args: ['class.k-header',] }],
    tabsAtTop: [{ type: HostBinding, args: ['class.k-tabstrip-top',] }],
    tabsAtRight: [{ type: HostBinding, args: ['class.k-tabstrip-right',] }],
    tabsAtBottom: [{ type: HostBinding, args: ['class.k-tabstrip-bottom',] }],
    tabsAtLeft: [{ type: HostBinding, args: ['class.k-tabstrip-left',] }],
    dir: [{ type: HostBinding, args: ['attr.dir',] }],
    tabs: [{ type: ContentChildren, args: [TabStripTabComponent,] }],
    tabHeadingContainers: [{ type: ViewChildren, args: ['tabHeadingContainer',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabStripComponent, [{
        type: Component,
        args: [{
                animations: [
                    trigger('state', [
                        state('active', style({ opacity: 1 })),
                        transition('* => active', [
                            style({ opacity: 0 }),
                            animate('400ms ease-in')
                        ])
                    ])
                ],
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.tabstrip'
                    }
                ],
                exportAs: 'kendoTabStrip',
                selector: 'kendo-tabstrip',
                template: `
        <ng-container *ngIf="!tabsAtBottom">
            <ng-container *ngTemplateOutlet="heading">
            </ng-container>
            <ng-container *ngTemplateOutlet="content">
            </ng-container>
        </ng-container>

        <ng-container *ngIf="tabsAtBottom">
            <ng-container *ngTemplateOutlet="content">
            </ng-container>
            <ng-container *ngTemplateOutlet="heading">
            </ng-container>
        </ng-container>

        <ng-template #heading>
            <ul
                class="k-reset k-tabstrip-items"
                [style.justifyContent]="tabsAlignment"
                role="tablist"
                (keydown)="onKeyDown($event)"
                #tablist
            >
                <li *ngFor="let tab of tabs; let i = index;" (click)="onTabClick($event, i)"
                    #tabHeadingContainer
                    role="tab"
                    [id]="tabId(i)"
                    [tabIndex]="tab.active ? 0 : -1"
                    [ngClass]="tab.cssClass"
                    [class.k-item]="true"
                    [class.k-state-default]="true"
                    [class.k-state-active]="tab.active"
                    [class.k-state-disabled]="tab.disabled"
                    [attr.aria-selected]="tab.active"
                    [attr.aria-controls]="tabPanelId(i)"
                    [attr.aria-disabled]="tab.disabled"
                ><span class="k-link">{{ tab.title }}<ng-template [ngTemplateOutlet]="tab.tabTitle?.templateRef"></ng-template></span></li>
            </ul>
        </ng-template>
        <ng-template #content>
            <ng-template ngFor let-tab [ngForOf]="tabs" let-i="index">
                <div
                    [@state]="tab.active && _animate ? 'active' : 'inactive'"
                    *ngIf="tab.active || keepTabContent"
                    [ngClass]="contentClass(tab.active)"
                    [tabIndex]="0"
                    role="tabpanel"
                    [id]="tabPanelId(i)"
                    [attr.aria-hidden]="!tab.active"
                    [attr.aria-expanded]="tab.active"
                    [attr.aria-labelledby]="tabId(i)"
                    [attr.aria-disabled]="tab.disabled"
                >
                    <ng-template [ngTemplateOutlet]="tab.tabContent?.templateRef"></ng-template>
                </div>
            </ng-template>
        </ng-template>
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { animate: [{
            type: Input
        }], tabPosition: [{
            type: Input
        }], keepTabContent: [{
            type: Input
        }], tabSelect: [{
            type: Output
        }], hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-tabstrip']
        }, {
            type: HostBinding,
            args: ['class.k-floatwrap']
        }, {
            type: HostBinding,
            args: ['class.k-header']
        }], height: [{
            type: Input
        }], tabsAtTop: [{
            type: HostBinding,
            args: ['class.k-tabstrip-top']
        }], tabsAtRight: [{
            type: HostBinding,
            args: ['class.k-tabstrip-right']
        }], tabsAtBottom: [{
            type: HostBinding,
            args: ['class.k-tabstrip-bottom']
        }], tabsAtLeft: [{
            type: HostBinding,
            args: ['class.k-tabstrip-left']
        }], dir: [{
            type: HostBinding,
            args: ['attr.dir']
        }], tabAlignment: [{
            type: Input
        }], tablist: [{
            type: ViewChild,
            args: ['tablist']
        }], tabs: [{
            type: ContentChildren,
            args: [TabStripTabComponent]
        }], tabHeadingContainers: [{
            type: ViewChildren,
            args: ['tabHeadingContainer']
        }] }); })();

/**
 * Represents a template that defines the content of the Drawer.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoDrawerTemplate` directive inside the `<kendo-drawer>` tag.
 * Using this template directive will override all other templates,
 * for example, `kendoDrawerHeaderTemplate` and `kendoDrawerItemTemplate`.
 */
class DrawerTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
DrawerTemplateDirective.ɵfac = function DrawerTemplateDirective_Factory(t) { return new (t || DrawerTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
DrawerTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DrawerTemplateDirective, selectors: [["", "kendoDrawerTemplate", ""]] });
/** @nocollapse */
DrawerTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoDrawerTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Represents a template that defines the item content of the Drawer.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoDrawerItemTemplate` directive inside the `<kendo-drawer>` tag.
 */
class DrawerItemTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
DrawerItemTemplateDirective.ɵfac = function DrawerItemTemplateDirective_Factory(t) { return new (t || DrawerItemTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
DrawerItemTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DrawerItemTemplateDirective, selectors: [["", "kendoDrawerItemTemplate", ""]] });
/** @nocollapse */
DrawerItemTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerItemTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoDrawerItemTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Represents a template that defines the header content of the Drawer.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoDrawerHeaderTemplate` directive inside the `<kendo-drawer>` tag.
 */
class DrawerHeaderTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
DrawerHeaderTemplateDirective.ɵfac = function DrawerHeaderTemplateDirective_Factory(t) { return new (t || DrawerHeaderTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
DrawerHeaderTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DrawerHeaderTemplateDirective, selectors: [["", "kendoDrawerHeaderTemplate", ""]] });
/** @nocollapse */
DrawerHeaderTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerHeaderTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoDrawerHeaderTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Represents a template that defines the footer content of the Drawer.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoDrawerFooterTemplate` directive inside the `<kendo-drawer>` tag.
 */
class DrawerFooterTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
DrawerFooterTemplateDirective.ɵfac = function DrawerFooterTemplateDirective_Factory(t) { return new (t || DrawerFooterTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
DrawerFooterTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DrawerFooterTemplateDirective, selectors: [["", "kendoDrawerFooterTemplate", ""]] });
/** @nocollapse */
DrawerFooterTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerFooterTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoDrawerFooterTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * @hidden
 */
function miniExpandPush(duration, width, miniWidth) {
    return [
        style({ overflow: 'hidden', flexBasis: `${miniWidth}px` }),
        animate(`${duration}ms ease-in`, style({ flexBasis: `${width}px` }))
    ];
}
/**
 * @hidden
 */
function miniCollapsePush(duration, width, miniWidth) {
    return [
        style({ overflow: 'hidden', flexBasis: `${width}px` }),
        animate(`${duration}ms ease-in`, style({ flexBasis: `${miniWidth}px` }))
    ];
}
/**
 * @hidden
 *
 */
function miniExpandOverlay(duration, width, miniWidth) {
    return [
        style({ width: `${miniWidth}px` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', width: `${width}px` }))
    ];
}
/**
 * @hidden
 */
function expandPush(duration, width) {
    return [
        style({ overflow: 'hidden', flexBasis: '0px' }),
        animate(`${duration}ms ease-in`, style({ flexBasis: `${width}px` }))
    ];
}
/**
 * @hidden
 */
function collapsePush(duration, width) {
    return [
        style({ flexBasis: `${width}px` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', flexBasis: `0px` }))
    ];
}
/**
 * @hidden
 */
function expandRTLOverlay(duration) {
    return [
        style({ transform: `translateX(100%)` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', transform: `translateX(0)` }))
    ];
}
/**
 * @hidden
 */
function expandOverlay(duration, position) {
    const translateDir = position !== 'end' ? `-100%` : `100%`;
    return [
        style({ transform: `translateX(${translateDir})` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', transform: `translateX(0)` }))
    ];
}
/**
 * @hidden
 */
function miniCollapseOverlay(duration, width, miniWidth) {
    return [
        style({ width: `${width}px` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', width: `${miniWidth}px` }))
    ];
}
/**
 * @hidden
 */
function collapseOverlay(duration, position) {
    const translateDir = position !== 'end' ? '-100%' : '100%';
    return [
        style({ transform: `translateX(0)` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', transform: `translateX(${translateDir})` }))
    ];
}
/**
 * @hidden
 */
function collapseRTLOverlay(duration) {
    return [
        style({ transform: `translateX(0)` }),
        animate(`${duration}ms ease-in`, style({ overflow: 'hidden', transform: `translateX(100%)` }))
    ];
}
/**
 * @hidden
 */
function expandAnimation(settings) {
    const duration = settings.animation.duration;
    const width = settings.width;
    const miniWidth = settings.miniWidth;
    const mode = settings.mode;
    const mini = settings.mini;
    const rtl = settings.rtl;
    const position = settings.position;
    if (mini && mode === 'push') {
        return miniExpandPush(duration, width, miniWidth);
    }
    if (!mini && mode === 'push') {
        return expandPush(duration, width);
    }
    if (!mini && mode === 'overlay') {
        return rtl ? expandRTLOverlay(duration) : expandOverlay(duration, position);
    }
    if (mini && mode === 'overlay') {
        return miniExpandOverlay(duration, width, miniWidth);
    }
}
/**
 * @hidden
 */
function collapseAnimation(settings) {
    const duration = settings.animation.duration;
    const width = settings.width;
    const miniWidth = settings.miniWidth;
    const mode = settings.mode;
    const mini = settings.mini;
    const rtl = settings.rtl;
    const position = settings.position;
    if (mini && mode === 'push') {
        return miniCollapsePush(duration, width, miniWidth);
    }
    if (!mini && mode === 'push') {
        return collapsePush(duration, width);
    }
    if (!mini && mode === 'overlay') {
        return rtl ? collapseRTLOverlay(duration) : collapseOverlay(duration, position);
    }
    if (mini && mode === 'overlay') {
        return miniCollapseOverlay(duration, width, miniWidth);
    }
}

/**
 * Arguments for the `select` event of the Drawer.
 */
class DrawerSelectEvent extends PreventableEvent {
}

/**
 * @hidden
 */
class DrawerService {
    constructor() {
        this.selectedIndices = [];
    }
    emit(event, args) {
        const drawer = this.owner;
        const eventArgs = new DrawerSelectEvent(Object.assign({}, args, { sender: drawer }));
        if (hasObservers(drawer[event])) {
            drawer[event].emit(eventArgs);
        }
        return eventArgs.isDefaultPrevented();
    }
    onSelect(selectedIdx) {
        this.selectedIndices = [selectedIdx];
        const drawer = this.owner;
        if (drawer.autoCollapse && !drawer.minimized) {
            drawer.toggle(false);
        }
    }
    initSelection() {
        const items = this.owner.items;
        this.selectedIndices = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].selected) {
                this.selectedIndices.push(i);
            }
        }
    }
}
DrawerService.ɵfac = function DrawerService_Factory(t) { return new (t || DrawerService)(); };
DrawerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DrawerService, factory: DrawerService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const DEFAULT_ANIMATION = { type: 'slide', duration: 200 };
/**
 * Represents the [Kendo UI Drawer component for Angular]({% slug overview_drawer %}).
 *
 * @example
 * ```ts-preview
 * _@Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-drawer-container>
 *             <kendo-drawer #drawer
 *                  [items]="items"
 *                  [mode]="'overlay'"
 *                  [(expanded)]="expanded">
 *              </kendo-drawer>
 *              <kendo-drawer-content>
 *                  <button class="k-button" (click)="drawer.toggle()">Open the Drawer</button>
 *              </kendo-drawer-content>
 *        </kendo-drawer-container>
 *    `
 * })
 * class AppComponent {
 *    public expanded = false;
 *
 *    public items: any[] = [
 *      { text: 'Inbox', icon: 'k-i-inbox' },
 *      { text: 'Notifications', icon: 'k-i-bell' },
 *      { text: 'Date', icon: 'k-i-calendar' }
 *    ];
 * }
 * ```
 */
class DrawerComponent {
    constructor(element, builder, localizationService, drawerService) {
        this.element = element;
        this.builder = builder;
        this.localizationService = localizationService;
        this.drawerService = drawerService;
        this.hostClasses = true;
        /**
         * Specifies the mode in which the Drawer will be displayed.
         *
         * The possible values are:
         * * (Default) `overlay`
         * * `push`
         */
        this.mode = 'overlay';
        /**
         * Specifies the position of the Drawer
         * ([see example]({% slug positioning_drawer %})).
         *
         * The possible values are:
         * * (Default) `start`
         * * `end`
         */
        this.position = 'start';
        /**
         * Enables the mini (compact) view of the Drawer which is displayed when the component is collapsed
         * ([see example]({% slug expandmodespositions_drawer %}#toc-mini-view)).
         */
        this.mini = false;
        /**
         * Specifies the state of the Drawer.
         */
        this.expanded = false;
        /**
         * Defines the width of the Drawer when it is expanded.
         * Defaults to `240`.
         */
        this.width = 240;
        /**
         * Defines the width of the Drawer when the mini view is enabled
         * and the component is collapsed. Defaults to `60`.
         */
        this.miniWidth = 50;
        /**
         * Specifies if the Drawer will be automatically collapsed when an item
         * or the overlay is clicked. Defaults to `true`.
         */
        this.autoCollapse = true;
        /**
         * Specifies the animation settings of the Drawer.
         * ([see example]({% slug interaction_drawer %}#toc-toggling-between-states)).
         *
         * The possible values are:
         * * Boolean
         *    * (Default) `true`
         *    * `false`
         * * `DrawerAnimation`
         *    * (Default) `type?: 'slide'`
         *    * `duration`&mdash;Accepts a number in milliseconds. Defaults to `300ms`.
         */
        this.animation = DEFAULT_ANIMATION;
        /**
         * Fires when the Drawer is expanded and its animation is complete.
         */
        this.expand = new EventEmitter();
        /**
         * Fires when the Drawer is collapsed and its animation is complete.
         */
        this.collapse = new EventEmitter();
        /**
         * Fires when a Drawer item is selected. This event is preventable.
         */
        this.select = new EventEmitter();
        /**
         * Fires when the `expanded` property of the component was updated.
         * Used to provide a two-way binding for the `expanded` property.
         */
        this.expandedChange = new EventEmitter();
        this.animationEnd = new EventEmitter();
        this.rtl = false;
        this._items = [];
        this.dynamicRTLSubscription = this.localizationService.changes.subscribe(({ rtl }) => {
            this.rtl = rtl;
            this.direction = this.rtl ? 'rtl' : 'ltr';
        });
        this.drawerService.owner = this;
    }
    get startPositionClass() {
        return this.position === 'start';
    }
    get endPositionClass() {
        return this.position === 'end';
    }
    get overlayTransofrmStyles() {
        if (this.mode === 'push') {
            return;
        }
        if (this.expanded || this.minimized) {
            return `translateX(0px)`;
        }
        return `translateX(-100%)`;
    }
    get flexStyles() {
        if (this.mode === 'overlay') {
            return;
        }
        if (!this.expanded && !this.minimized) {
            return 0;
        }
        return this.drawerWidth;
    }
    /**
     * The collection of items that will be rendered in the Drawer.
     */
    set items(items) {
        if (isPresent(items)) {
            this._items = items;
            this.drawerService.initSelection();
        }
    }
    get items() {
        return this._items;
    }
    ngOnDestroy() {
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    get minimized() {
        return this.mini && !this.expanded;
    }
    /**
     * @hidden
     */
    get drawerWidth() {
        return this.minimized ? this.miniWidth : this.width;
    }
    /**
     * Toggles the visibility of the Drawer.
     *
     * @param expanded? - Boolean. Specifies if the Drawer will be expanded or collapsed.
     */
    toggle(expanded) {
        const previous = this.expanded;
        const current = isPresent(expanded) ? expanded : !previous;
        if (current === previous) {
            return;
        }
        if (current === true) {
            this.setExpanded(true);
        }
        else if (current === false && !this.animation) {
            this.setExpanded(false);
        }
        if (this.animation) {
            this.animationEnd.pipe(take(1))
                .subscribe(() => { this.onAnimationEnd(current); });
            this.animate(current);
        }
        else {
            this[current ? 'expand' : 'collapse'].emit();
        }
    }
    onAnimationEnd(currentExpanded) {
        if (currentExpanded) {
            this.expand.emit();
        }
        else {
            this.setExpanded(false);
            this.collapse.emit();
        }
    }
    setExpanded(value) {
        this.expanded = value;
        this.expandedChange.emit(value);
    }
    animate(expanded) {
        const settings = {
            mode: this.mode,
            mini: this.mini,
            miniWidth: this.miniWidth,
            width: this.width,
            rtl: this.rtl,
            position: this.position,
            animation: (typeof this.animation !== 'boolean') ? this.animation : DEFAULT_ANIMATION
        };
        const animation = expanded ? expandAnimation(settings) : collapseAnimation(settings);
        const player = this.createPlayer(animation, this.element.nativeElement);
        player.play();
    }
    createPlayer(animation, animatedElement) {
        const factory = this.builder.build(animation);
        let player = factory.create(animatedElement);
        player.onDone(() => {
            if (player) {
                this.animationEnd.emit();
                player.destroy();
                player = null;
            }
        });
        return player;
    }
}
DrawerComponent.ɵfac = function DrawerComponent_Factory(t) { return new (t || DrawerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.AnimationBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(DrawerService)); };
DrawerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DrawerComponent, selectors: [["kendo-drawer"]], contentQueries: function DrawerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DrawerTemplateDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DrawerFooterTemplateDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DrawerHeaderTemplateDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DrawerItemTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.drawerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
    } }, hostVars: 13, hostBindings: function DrawerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵstyleProp("transform", ctx.overlayTransofrmStyles)("flex-basis", ctx.flexStyles, "px");
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-drawer", ctx.hostClasses)("k-drawer-start", ctx.startPositionClass)("k-drawer-end", ctx.endPositionClass);
    } }, inputs: { mode: "mode", position: "position", mini: "mini", expanded: "expanded", width: "width", miniWidth: "miniWidth", autoCollapse: "autoCollapse", animation: "animation", items: "items" }, outputs: { expand: "expand", collapse: "collapse", select: "select", expandedChange: "expandedChange" }, exportAs: ["kendoDrawer"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            DrawerService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.drawer'
            }
        ])], decls: 1, vars: 1, consts: [["class", "k-drawer-wrapper", 3, "width", 4, "ngIf"], [1, "k-drawer-wrapper"], [4, "ngIf"], ["kendoDrawerList", "", 1, "k-drawer-items", 3, "items", "mini", "expanded", "itemTemplate"], [3, "ngTemplateOutlet"]], template: function DrawerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DrawerComponent_div_0_Template, 3, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.expanded || ctx.mini);
    } }, directives: function () { return [ɵngcc1.NgIf, DrawerListComponent, ɵngcc1.NgTemplateOutlet]; }, encapsulation: 2 });
/** @nocollapse */
DrawerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: AnimationBuilder },
    { type: LocalizationService },
    { type: DrawerService }
];
DrawerComponent.propDecorators = {
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-drawer',] }],
    startPositionClass: [{ type: HostBinding, args: ['class.k-drawer-start',] }],
    endPositionClass: [{ type: HostBinding, args: ['class.k-drawer-end',] }],
    overlayTransofrmStyles: [{ type: HostBinding, args: ['style.transform',] }],
    flexStyles: [{ type: HostBinding, args: ['style.flexBasis.px',] }],
    mode: [{ type: Input }],
    position: [{ type: Input }],
    mini: [{ type: Input }],
    expanded: [{ type: Input }],
    width: [{ type: Input }],
    miniWidth: [{ type: Input }],
    autoCollapse: [{ type: Input }],
    items: [{ type: Input }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    animation: [{ type: Input }],
    expand: [{ type: Output }],
    collapse: [{ type: Output }],
    select: [{ type: Output }],
    expandedChange: [{ type: Output }],
    drawerTemplate: [{ type: ContentChild, args: [DrawerTemplateDirective,] }],
    footerTemplate: [{ type: ContentChild, args: [DrawerFooterTemplateDirective,] }],
    headerTemplate: [{ type: ContentChild, args: [DrawerHeaderTemplateDirective,] }],
    itemTemplate: [{ type: ContentChild, args: [DrawerItemTemplateDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoDrawer',
                providers: [
                    LocalizationService,
                    DrawerService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.drawer'
                    }
                ],
                selector: 'kendo-drawer',
                template: `
        <div class="k-drawer-wrapper" *ngIf="expanded || mini" [style.width.px]="drawerWidth">
            <ng-container *ngIf="!drawerTemplate">
                <ng-template *ngIf="headerTemplate"
                    [ngTemplateOutlet]="headerTemplate?.templateRef">
                </ng-template>

                <ul kendoDrawerList
                    [items]="items" [mini]="mini" [expanded]="expanded"
                    [itemTemplate]="itemTemplate?.templateRef"
                    class="k-drawer-items">
                </ul>

                <ng-template *ngIf="footerTemplate"
                    [ngTemplateOutlet]="footerTemplate?.templateRef">
                </ng-template>
            </ng-container>

            <ng-template *ngIf="drawerTemplate"
                [ngTemplateOutlet]="drawerTemplate?.templateRef">
            </ng-template>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc4.AnimationBuilder }, { type: ɵngcc2.LocalizationService }, { type: DrawerService }]; }, { hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-drawer']
        }], mode: [{
            type: Input
        }], position: [{
            type: Input
        }], mini: [{
            type: Input
        }], expanded: [{
            type: Input
        }], width: [{
            type: Input
        }], miniWidth: [{
            type: Input
        }], autoCollapse: [{
            type: Input
        }], animation: [{
            type: Input
        }], expand: [{
            type: Output
        }], collapse: [{
            type: Output
        }], select: [{
            type: Output
        }], expandedChange: [{
            type: Output
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], startPositionClass: [{
            type: HostBinding,
            args: ['class.k-drawer-start']
        }], endPositionClass: [{
            type: HostBinding,
            args: ['class.k-drawer-end']
        }], overlayTransofrmStyles: [{
            type: HostBinding,
            args: ['style.transform']
        }], flexStyles: [{
            type: HostBinding,
            args: ['style.flexBasis.px']
        }], items: [{
            type: Input
        }], drawerTemplate: [{
            type: ContentChild,
            args: [DrawerTemplateDirective]
        }], footerTemplate: [{
            type: ContentChild,
            args: [DrawerFooterTemplateDirective]
        }], headerTemplate: [{
            type: ContentChild,
            args: [DrawerHeaderTemplateDirective]
        }], itemTemplate: [{
            type: ContentChild,
            args: [DrawerItemTemplateDirective]
        }] }); })();

/**
 * Serves as a container for the [Kendo UI Drawer component for Angular]({% slug overview_drawer %}) and its content.
 */
class DrawerContainerComponent {
    constructor(localizationService) {
        this.localizationService = localizationService;
        this.rtl = false;
        this.dynamicRTLSubscription = this.localizationService.changes.subscribe(({ rtl }) => {
            this.rtl = rtl;
            this.direction = this.rtl ? 'rtl' : 'ltr';
        });
    }
    get hostClass() {
        return true;
    }
    get overlayClass() {
        return this.drawer.mode === 'overlay';
    }
    get miniClass() {
        return this.drawer.mini;
    }
    get pushClass() {
        return this.drawer.mode === 'push';
    }
    get isExpandedClass() {
        return this.drawer.expanded;
    }
    ngOnDestroy() {
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    /**
     * @hidden
     */
    get overlay() {
        return isPresent(this.drawer) &&
            this.drawer.expanded &&
            this.drawer.mode === 'overlay';
    }
    /**
     * @hidden
     */
    closeDrawer() {
        if (this.overlay && this.drawer.autoCollapse) {
            this.drawer.toggle(false);
        }
    }
}
DrawerContainerComponent.ɵfac = function DrawerContainerComponent_Factory(t) { return new (t || DrawerContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
DrawerContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DrawerContainerComponent, selectors: [["kendo-drawer-container"]], contentQueries: function DrawerContainerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DrawerComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.drawer = _t.first);
    } }, hostVars: 11, hostBindings: function DrawerContainerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵclassProp("k-drawer-container", ctx.hostClass)("k-drawer-overlay", ctx.overlayClass)("k-drawer-mini", ctx.miniClass)("k-drawer-push", ctx.pushClass)("k-drawer-expanded", ctx.isExpandedClass);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.drawer.container'
            }
        ])], ngContentSelectors: _c6, decls: 2, vars: 1, consts: [["class", "k-overlay", 3, "click", 4, "ngIf"], [1, "k-overlay", 3, "click"]], template: function DrawerContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DrawerContainerComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.overlay);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
/** @nocollapse */
DrawerContainerComponent.ctorParameters = () => [
    { type: LocalizationService }
];
DrawerContainerComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-drawer-container',] }],
    overlayClass: [{ type: HostBinding, args: ['class.k-drawer-overlay',] }],
    miniClass: [{ type: HostBinding, args: ['class.k-drawer-mini',] }],
    pushClass: [{ type: HostBinding, args: ['class.k-drawer-push',] }],
    isExpandedClass: [{ type: HostBinding, args: ['class.k-drawer-expanded',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    drawer: [{ type: ContentChild, args: [DrawerComponent,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerContainerComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-drawer-container',
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.drawer.container'
                    }
                ],
                template: `
        <div class="k-overlay" *ngIf="overlay" (click)="closeDrawer()"></div>
        <ng-content></ng-content>
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, { direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], hostClass: [{
            type: HostBinding,
            args: ['class.k-drawer-container']
        }], overlayClass: [{
            type: HostBinding,
            args: ['class.k-drawer-overlay']
        }], miniClass: [{
            type: HostBinding,
            args: ['class.k-drawer-mini']
        }], pushClass: [{
            type: HostBinding,
            args: ['class.k-drawer-push']
        }], isExpandedClass: [{
            type: HostBinding,
            args: ['class.k-drawer-expanded']
        }], drawer: [{
            type: ContentChild,
            args: [DrawerComponent]
        }] }); })();

/**
 * Represents the content of the [Kendo UI Drawer component for Angular]({% slug overview_drawer %}).
 */
class DrawerContentComponent {
    constructor() {
        this.hostClasses = true;
    }
}
DrawerContentComponent.ɵfac = function DrawerContentComponent_Factory(t) { return new (t || DrawerContentComponent)(); };
DrawerContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DrawerContentComponent, selectors: [["kendo-drawer-content"]], hostVars: 2, hostBindings: function DrawerContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-drawer-content", ctx.hostClasses);
    } }, ngContentSelectors: _c6, decls: 1, vars: 0, template: function DrawerContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/** @nocollapse */
DrawerContentComponent.ctorParameters = () => [];
DrawerContentComponent.propDecorators = {
    hostClasses: [{ type: HostBinding, args: ['class.k-drawer-content',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerContentComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-drawer-content',
                template: `
        <ng-content></ng-content>
    `,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { hostClasses: [{
            type: HostBinding,
            args: ['class.k-drawer-content']
        }] }); })();

/**
 * Represents a template that defines the content of the whole Step.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoStepperStepTemplate` directive inside the `<kendo-stepper>` tag.
 */
class StepperStepTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
StepperStepTemplateDirective.ɵfac = function StepperStepTemplateDirective_Factory(t) { return new (t || StepperStepTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
StepperStepTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: StepperStepTemplateDirective, selectors: [["", "kendoStepperStepTemplate", ""]] });
/** @nocollapse */
StepperStepTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperStepTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoStepperStepTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Represents a template that defines the content of the Step label.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoStepperLabelTemplate` directive inside the `<kendo-stepper>` tag.
 */
class StepperLabelTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
StepperLabelTemplateDirective.ɵfac = function StepperLabelTemplateDirective_Factory(t) { return new (t || StepperLabelTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
StepperLabelTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: StepperLabelTemplateDirective, selectors: [["", "kendoStepperLabelTemplate", ""]] });
/** @nocollapse */
StepperLabelTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperLabelTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoStepperLabelTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Represents a template that defines the content of the Step indicator.
 * To define the template, nest an `<ng-template>` tag
 * with the `kendoStepperIndicatorTemplate` directive inside the `<kendo-stepper>` tag.
 */
class StepperIndicatorTemplateDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
StepperIndicatorTemplateDirective.ɵfac = function StepperIndicatorTemplateDirective_Factory(t) { return new (t || StepperIndicatorTemplateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef, 8)); };
StepperIndicatorTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: StepperIndicatorTemplateDirective, selectors: [["", "kendoStepperIndicatorTemplate", ""]] });
/** @nocollapse */
StepperIndicatorTemplateDirective.ctorParameters = () => [
    { type: TemplateRef, decorators: [{ type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperIndicatorTemplateDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoStepperIndicatorTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Optional
            }] }]; }, null); })();

/**
 * Arguments for the `activate` event of the Stepper.
 */
class StepperActivateEvent extends PreventableEvent {
}

const DEFAULT_CURRENT_STEP = 0;
const handlers = {};
handlers[Keys.ArrowLeft] = 'left';
handlers[Keys.ArrowRight] = 'right';
handlers[Keys.ArrowUp] = 'up';
handlers[Keys.ArrowDown] = 'down';
handlers[Keys.Home] = 'home';
handlers[Keys.End] = 'end';
handlers[Keys.Enter] = 'enter';
handlers[Keys.Space] = 'enter';
const handlersRTL = Object.assign({}, handlers);
handlersRTL[Keys.ArrowLeft] = 'right';
handlersRTL[Keys.ArrowRight] = 'left';
/**
 * @hidden
 */
class StepperService {
    constructor(localization, ngZone, changeDetector) {
        this.localization = localization;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.currentStep = DEFAULT_CURRENT_STEP;
        this.triggerValidation = new EventEmitter();
        this.focusedStepChange = new EventEmitter();
    }
    get handlers() {
        return this.localization.rtl ? handlersRTL : handlers;
    }
    emit(event, eventArgs) {
        const stepper = this.owner;
        if (hasObservers(stepper[event])) {
            stepper[event].emit(eventArgs);
        }
        return eventArgs.isDefaultPrevented();
    }
    onActivate(currentIdx, originalEvent) {
        const eventArgs = new StepperActivateEvent({
            index: currentIdx,
            step: this.owner.steps[currentIdx],
            originalEvent: originalEvent,
            sender: this.owner
        });
        this.ngZone.run(() => {
            if (!this.emit('activate', eventArgs)) {
                this.currentStep = currentIdx;
                this.owner['currentStepChange'].emit(currentIdx);
                this.changeDetector.detectChanges();
            }
        });
    }
    validateSteps() {
        this.triggerValidation.emit();
    }
    keydown(e) {
        const current = this.focusedStep || this.currentStep;
        const handler = this.handlers[e.keyCode];
        if (!isPresent(current)) {
            return;
        }
        if (handler) {
            e.preventDefault();
            this[handler](e);
        }
    }
    left() {
        if (!this.isHorizontal) {
            return;
        }
        this.focusPrevStep();
    }
    right() {
        if (!this.isHorizontal) {
            return;
        }
        this.focusNextStep();
    }
    up() {
        if (this.isHorizontal) {
            return;
        }
        this.focusPrevStep();
    }
    down() {
        if (this.isHorizontal) {
            return;
        }
        this.focusNextStep();
    }
    home() {
        this.focusedStep = 0;
        this.focusedStepChange.emit();
    }
    end() {
        this.focusedStep = this.owner.steps.length - 1;
        this.focusedStepChange.emit();
    }
    enter(event) {
        if (this.focusedStep === this.currentStep) {
            return;
        }
        if (this.isStepDisabled(this.focusedStep)) {
            return;
        }
        if (this.owner.linear && this.isPrevOrNextStep(this.focusedStep) === false) {
            return;
        }
        this.onActivate(this.focusedStep, event);
    }
    focus(focusedIdx) {
        this.focusedStep = focusedIdx;
    }
    focusNextStep() {
        if (this.focusedStep < this.owner.steps.length) {
            this.focusedStep += 1;
            this.focusedStepChange.emit();
        }
    }
    focusPrevStep() {
        if (this.focusedStep > 0) {
            this.focusedStep -= 1;
            this.focusedStepChange.emit();
        }
    }
    isStepDisabled(index) {
        return this.owner.steps[index].disabled;
    }
    isPrevOrNextStep(index) {
        return index === this.currentStep + 1 || index === this.currentStep - 1;
    }
    get isHorizontal() {
        return this.owner.orientation === 'horizontal';
    }
}
StepperService.ɵfac = function StepperService_Factory(t) { return new (t || StepperService)(ɵngcc0.ɵɵinject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ɵngcc0.ChangeDetectorRef)); };
StepperService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: StepperService, factory: StepperService.ɵfac });
/** @nocollapse */
StepperService.ctorParameters = () => [
    { type: LocalizationService },
    { type: NgZone },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.LocalizationService }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

const DEFAULT_ANIMATION_DURATION = 400;
/**
 * Represents the [Kendo UI Stepper component for Angular]({% slug overview_stepper %}).
 *
 * @example
 * ```ts-preview
 * _@Component({
 *    selector: 'my-app',
 *    template: `
 *        <kendo-stepper [steps]="steps">
 *        </kendo-stepper>
 *    `
 * })
 * class AppComponent {
 *    public steps: Array<StepperStep> = [
 *      { label: 'Step One' }, { label: 'Step Two' }, { label: 'Step Three' }
 *    ];
 * }
 * ```
 */
class StepperComponent {
    constructor(renderer, elem, localization, stepperService) {
        this.renderer = renderer;
        this.elem = elem;
        this.localization = localization;
        this.stepperService = stepperService;
        this.hostClasses = true;
        this.ariaRole = 'navigation';
        this.displayStyle = 'grid';
        /**
         * Specifies the type of the steps in the Stepper.
         *
         * The possible values are:
         * * (Default) `indicator`
         * * `label`
         * * `full`
         */
        this.stepType = 'indicator';
        /**
         * Specifies the linear flow of the Stepper.
         *
         * @default true
         */
        this.linear = true;
        /**
         * Specifies the orientation of the Stepper
         * ([see example]({% slug orientation_stepper %})).
         *
         * The possible values are:
         * * (Default) `horizontal`
         * * `vertical`
         */
        this.orientation = 'horizontal';
        /**
         * Specifies the duration of the progress indicator animation in milliseconds. Defaults to `400ms`.
         *
         * The possible values are:
         *  * Boolean
         *    * (Default) `true`
         *    * false
         *  * Number
         */
        this.animation = true;
        /**
         * Fires when a step is about to be activated. This event is preventable.
         */
        this.activate = new EventEmitter();
        /**
         * Fires when the `currentStep` property of the component was updated.
         * Used to provide a two-way binding for the `currentStep` property.
         */
        this.currentStepChange = new EventEmitter();
        this._steps = [];
        this.dynamicRTLSubscription = this.localization.changes.subscribe(({ rtl }) => {
            this.direction = rtl ? 'rtl' : 'ltr';
        });
        this.stepperService.owner = this;
    }
    get linearClass() {
        return this.linear;
    }
    /**
     * The index of the current step.
     */
    set currentStep(value) {
        this.stepperService.currentStep = value;
    }
    get currentStep() {
        return this.stepperService.currentStep;
    }
    /**
     * The collection of steps that will be rendered in the Stepper.
     * ([see example]({% slug step_appearance_stepper %}))
     */
    set steps(steps) {
        if (isPresent(steps) && steps.length > 0) {
            this._steps = steps;
        }
    }
    get steps() {
        return this._steps;
    }
    ngOnInit() {
        this.applyHostStyling();
    }
    ngOnChanges(changes) {
        if (changes.steps && !changes.steps.firstChange) {
            this.applyHostStyling();
        }
    }
    ngOnDestroy() {
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
    /**
     * Manually triggers the validity check configured by the [isValid]({% slug api_layout_stepperstep %}#toc-isvalid) property of the steps.
     *
     * Steps that have their [validate]({% slug api_layout_stepperstep %}#toc-validate) property set to `false`, will not be validated.
     */
    validateSteps() {
        this.stepperService.validateSteps();
    }
    applyHostStyling() {
        const stepFramesStyle = this.orientation === 'horizontal' ? 'grid-template-columns' : 'grid-template-rows';
        const stepFramesValue = `repeat(${this.steps.length * 2}, 1fr)`;
        this.renderer.setStyle(this.elem.nativeElement, stepFramesStyle, stepFramesValue);
    }
    /**
     * @hidden
     */
    get progressAnimation() {
        return { duration: this.animationDuration };
    }
    /**
     * @hidden
     */
    get animationDuration() {
        if (typeof this.animation === 'number') {
            return this.animation;
        }
        if (typeof this.animation === 'boolean' && this.animation) {
            return DEFAULT_ANIMATION_DURATION;
        }
        return 0;
    }
    /**
     * @hidden
     */
    get stepsListStyling() {
        if (this.orientation === 'horizontal') {
            return { 'grid-column-start': 1, 'grid-column-end': -1 };
        }
        return { 'grid-row-start': 1, 'grid-row-end': -1 };
    }
    /**
     * @hidden
     */
    get progressBarStyling() {
        if (this.orientation === 'horizontal') {
            return {
                'grid-column-start': 2,
                'grid-column-end': this.steps.length * 2
            };
        }
        return {
            'grid-row-start': 2,
            'grid-row-end': this.steps.length * 2
        };
    }
    /***
     * @hidden
     */
    get isHorizontal() {
        return this.stepperService.isHorizontal;
    }
}
StepperComponent.ɵfac = function StepperComponent_Factory(t) { return new (t || StepperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(StepperService)); };
StepperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StepperComponent, selectors: [["kendo-stepper"]], contentQueries: function StepperComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, StepperStepTemplateDirective, true);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, StepperLabelTemplateDirective, true);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, StepperIndicatorTemplateDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.labelTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.indicatorTemplate = _t.first);
    } }, hostVars: 10, hostBindings: function StepperComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.ariaRole)("dir", ctx.direction);
        ɵngcc0.ɵɵstyleProp("display", ctx.displayStyle);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClasses)("k-stepper", ctx.hostClasses)("k-stepper-linear", ctx.linearClass);
    } }, inputs: { stepType: "stepType", linear: "linear", orientation: "orientation", animation: "animation", currentStep: "currentStep", steps: "steps", successIcon: "successIcon", errorIcon: "errorIcon" }, outputs: { activate: "activate", currentStepChange: "currentStepChange" }, exportAs: ["kendoStepper"], features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            StepperService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.stepper'
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 16, consts: [["kendoStepperLocalizedMessages", "", 6, "optional"], ["kendoStepperList", "", 1, "k-step-list", 3, "stepType", "linear", "orientation", "steps", "currentStep", "successIcon", "errorIcon", "indicatorTemplate", "labelTemplate", "stepTemplate", "ngStyle"], [3, "animation", "max", "label", "orientation", "reverse", "value", "ngStyle", 4, "ngIf"], [3, "animation", "max", "label", "orientation", "reverse", "value", "ngStyle"]], template: function StepperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵi18nAttributes(1, _c13);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelement(2, "ol", 1);
        ɵngcc0.ɵɵtemplate(3, StepperComponent_kendo_progressbar_3_Template, 1, 8, "kendo-progressbar", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("k-step-list-horizontal", ctx.isHorizontal)("k-step-list-vertical", !ctx.isHorizontal);
        ɵngcc0.ɵɵproperty("stepType", ctx.stepType)("linear", ctx.linear)("orientation", ctx.orientation)("steps", ctx.steps)("currentStep", ctx.currentStep)("successIcon", ctx.successIcon)("errorIcon", ctx.errorIcon)("indicatorTemplate", ctx.indicatorTemplate == null ? null : ctx.indicatorTemplate.templateRef)("labelTemplate", ctx.labelTemplate == null ? null : ctx.labelTemplate.templateRef)("stepTemplate", ctx.stepTemplate == null ? null : ctx.stepTemplate.templateRef)("ngStyle", ctx.stepsListStyling);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.steps.length > 0);
    } }, directives: function () { return [LocalizedMessagesDirective, StepperListComponent, ɵngcc1.NgStyle, ɵngcc1.NgIf, ɵngcc5.ProgressBarComponent]; }, encapsulation: 2 });
/** @nocollapse */
StepperComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: LocalizationService },
    { type: StepperService }
];
StepperComponent.propDecorators = {
    hostClasses: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-stepper',] }],
    linearClass: [{ type: HostBinding, args: ['class.k-stepper-linear',] }],
    ariaRole: [{ type: HostBinding, args: ['attr.role',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    displayStyle: [{ type: HostBinding, args: ['style.display',] }],
    stepType: [{ type: Input }],
    linear: [{ type: Input }],
    orientation: [{ type: Input }],
    currentStep: [{ type: Input }],
    steps: [{ type: Input }],
    successIcon: [{ type: Input }],
    errorIcon: [{ type: Input }],
    animation: [{ type: Input }],
    activate: [{ type: Output }],
    currentStepChange: [{ type: Output }],
    stepTemplate: [{ type: ContentChild, args: [StepperStepTemplateDirective, { static: true },] }],
    labelTemplate: [{ type: ContentChild, args: [StepperLabelTemplateDirective, { static: true },] }],
    indicatorTemplate: [{ type: ContentChild, args: [StepperIndicatorTemplateDirective, { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperComponent, [{
        type: Component,
        args: [{
                exportAs: 'kendoStepper',
                providers: [
                    LocalizationService,
                    StepperService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.stepper'
                    }
                ],
                selector: 'kendo-stepper',
                template: `
        <ng-container kendoStepperLocalizedMessages
            i18n-optional="kendo.stepper.optional|The text for the optional segment of the step label"
            optional="Optional"
         >
        </ng-container>
        <ol kendoStepperList
            [stepType]='stepType'
            [linear]='linear'
            [orientation]='orientation'
            [steps]='steps'
            [currentStep]='currentStep'
            [successIcon]='successIcon'
            [errorIcon]='errorIcon'
            [indicatorTemplate]='indicatorTemplate?.templateRef'
            [labelTemplate]='labelTemplate?.templateRef'
            [stepTemplate]='stepTemplate?.templateRef'
            class='k-step-list'
            [class.k-step-list-horizontal]='isHorizontal'
            [class.k-step-list-vertical]='!isHorizontal'
            [ngStyle]='stepsListStyling'>
        </ol>

        <kendo-progressbar *ngIf='steps.length > 0'
            [attr.aria-hidden]='true'
            [animation]='progressAnimation'
            [max]='steps.length - 1'
            [label]='false'
            [orientation]='orientation'
            [reverse]='!isHorizontal'
            [value]='currentStep'
            [ngStyle]='progressBarStyling'>
        </kendo-progressbar>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc2.LocalizationService }, { type: StepperService }]; }, { hostClasses: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-stepper']
        }], ariaRole: [{
            type: HostBinding,
            args: ['attr.role']
        }], displayStyle: [{
            type: HostBinding,
            args: ['style.display']
        }], stepType: [{
            type: Input
        }], linear: [{
            type: Input
        }], orientation: [{
            type: Input
        }], animation: [{
            type: Input
        }], activate: [{
            type: Output
        }], currentStepChange: [{
            type: Output
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], linearClass: [{
            type: HostBinding,
            args: ['class.k-stepper-linear']
        }], currentStep: [{
            type: Input
        }], steps: [{
            type: Input
        }], successIcon: [{
            type: Input
        }], errorIcon: [{
            type: Input
        }], stepTemplate: [{
            type: ContentChild,
            args: [StepperStepTemplateDirective, { static: true }]
        }], labelTemplate: [{
            type: ContentChild,
            args: [StepperLabelTemplateDirective, { static: true }]
        }], indicatorTemplate: [{
            type: ContentChild,
            args: [StepperIndicatorTemplateDirective, { static: true }]
        }] }); })();

/**
 * Displays images, icons or initials representing people or other entities.
 */
class AvatarComponent {
    constructor() {
        this.hostClass = true;
        /**
         * Sets the shape for the avatar.
         *
         * Possible values are:
         * * (Default) `square`
         * * `circle`
         * * `rounded`
         *
         */
        this.shape = 'square';
        /**
         * Sets the width of the avatar.
         */
        this.width = '32px';
        /**
         * Sets the height of the avatar.
         */
        this.height = '32px';
    }
    /**
     * @hidden
     */
    get circleClass() {
        return this.shape === 'circle';
    }
    /**
     * @hidden
     */
    get roundedClass() {
        return this.shape === 'rounded';
    }
    /**
     * @hidden
     */
    get squareClass() {
        return this.shape === 'square';
    }
    /**
     * @hidden
     */
    get avatarWidth() {
        return this.width;
    }
    /**
     * @hidden
     */
    get avatarHeight() {
        return this.height;
    }
    /**
     * @hidden
     */
    get initialsAvatar() {
        return Boolean(this.initials);
    }
    /**
     * @hidden
     */
    get imageAvatar() {
        return Boolean(this.imageSrc);
    }
    /**
     * @hidden
     */
    get iconAvatar() {
        return Boolean(this.icon || this.iconClass);
    }
    /**
     * @hidden
     */
    get imageUrl() {
        return `url(${this.imageSrc})`;
    }
    ngOnInit() {
        this.verifyProperties();
    }
    /**
     * @hidden
     */
    iconClasses() {
        if (this.icon) {
            return `k-icon k-i-${this.icon}`;
        }
        if (this.iconClass) {
            return `${this.iconClass}`;
        }
    }
    /**
     * @hidden
     */
    get customAvatar() {
        return !(this.imageSrc || this.initials || this.icon || this.iconClass);
    }
    verifyProperties() {
        if (!isDevMode()) {
            return;
        }
        const inputs = [this.icon || this.iconClass, this.imageSrc, this.initials];
        const inputsLength = inputs.filter((value) => value).length;
        if (inputsLength > 1) {
            throw new Error(`
                Invalid property configuration given.
                The kendo-avatar component can accept only one of:
                icon, imageSrc or initials properties.
            `);
        }
    }
}
AvatarComponent.ɵfac = function AvatarComponent_Factory(t) { return new (t || AvatarComponent)(); };
AvatarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AvatarComponent, selectors: [["kendo-avatar"]], hostVars: 18, hostBindings: function AvatarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.avatarWidth)("height", ctx.avatarHeight);
        ɵngcc0.ɵɵclassProp("k-avatar", ctx.hostClass)("k-avatar-circle", ctx.circleClass)("k-avatar-rounded", ctx.roundedClass)("k-avatar-square", ctx.squareClass)("k-avatar-initials", ctx.initialsAvatar)("k-avatar-image", ctx.imageAvatar)("k-avatar-icon", ctx.iconAvatar);
    } }, inputs: { shape: "shape", width: "width", height: "height", iconClass: "iconClass", cssStyle: "cssStyle", initials: "initials", icon: "icon", imageSrc: "imageSrc" }, ngContentSelectors: _c6, decls: 4, vars: 4, consts: [[4, "ngIf"], [3, "ngStyle"], [3, "ngStyle", "ngClass"]], template: function AvatarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, AvatarComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
        ɵngcc0.ɵɵtemplate(1, AvatarComponent_ng_container_1_Template, 2, 7, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, AvatarComponent_ng_container_2_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(3, AvatarComponent_ng_container_3_Template, 2, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.customAvatar);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageSrc);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.initials);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon || ctx.iconClass);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgStyle, ɵngcc1.NgClass], encapsulation: 2 });
AvatarComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-avatar',] }],
    shape: [{ type: Input }],
    circleClass: [{ type: HostBinding, args: ['class.k-avatar-circle',] }],
    roundedClass: [{ type: HostBinding, args: ['class.k-avatar-rounded',] }],
    squareClass: [{ type: HostBinding, args: ['class.k-avatar-square',] }],
    iconClass: [{ type: Input }],
    width: [{ type: Input }],
    avatarWidth: [{ type: HostBinding, args: ['style.width',] }],
    height: [{ type: Input }],
    avatarHeight: [{ type: HostBinding, args: ['style.height',] }],
    initialsAvatar: [{ type: HostBinding, args: ['class.k-avatar-initials',] }],
    imageAvatar: [{ type: HostBinding, args: ['class.k-avatar-image',] }],
    iconAvatar: [{ type: HostBinding, args: ['class.k-avatar-icon',] }],
    cssStyle: [{ type: Input }],
    initials: [{ type: Input }],
    icon: [{ type: Input }],
    imageSrc: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AvatarComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-avatar',
                template: `
        <ng-content *ngIf="customAvatar"></ng-content>

        <ng-container *ngIf="imageSrc">
            <div [style.width]="width" [style.height]="height" [ngStyle]="cssStyle" [style.backgroundImage]="imageUrl"></div>
        </ng-container>

        <ng-container *ngIf="initials">
            <span [ngStyle]="cssStyle">{{ initials.substring(0, 2) }}</span>
        </ng-container>

        <ng-container *ngIf="icon || iconClass">
            <span [ngStyle]="cssStyle" [ngClass]="iconClasses()"></span>
        </ng-container>
    `
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-avatar']
        }], shape: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], circleClass: [{
            type: HostBinding,
            args: ['class.k-avatar-circle']
        }], roundedClass: [{
            type: HostBinding,
            args: ['class.k-avatar-rounded']
        }], squareClass: [{
            type: HostBinding,
            args: ['class.k-avatar-square']
        }], avatarWidth: [{
            type: HostBinding,
            args: ['style.width']
        }], avatarHeight: [{
            type: HostBinding,
            args: ['style.height']
        }], initialsAvatar: [{
            type: HostBinding,
            args: ['class.k-avatar-initials']
        }], imageAvatar: [{
            type: HostBinding,
            args: ['class.k-avatar-image']
        }], iconAvatar: [{
            type: HostBinding,
            args: ['class.k-avatar-icon']
        }], iconClass: [{
            type: Input
        }], cssStyle: [{
            type: Input
        }], initials: [{
            type: Input
        }], icon: [{
            type: Input
        }], imageSrc: [{
            type: Input
        }] }); })();

/**
 * Represents the [Kendo UI Card component for Angular]({% slug overview_card %})
 */
class CardComponent {
    constructor(localizationService) {
        this.localizationService = localizationService;
        this.hostClass = true;
        /**
         * Specifies the layout of the Card content.
         *
         * The possible values are:
         * * (Default) `vertical`
         * * `horizontal`
         *
         */
        this.orientation = 'vertical';
        /**
         * Defines the width of the Card.
         * Defaults to `285px`.
         */
        this.width = '285px';
        this.rtl = false;
        this.dynamicRTLSubscription = this.localizationService.changes.subscribe(({ rtl }) => {
            this.rtl = rtl;
            this.direction = this.rtl ? 'rtl' : 'ltr';
        });
    }
    get widthStyle() {
        return this.width;
    }
    get vertical() {
        return this.orientation === 'vertical';
    }
    get horizontal() {
        return this.orientation === 'horizontal';
    }
    ngOnDestroy() {
        if (this.dynamicRTLSubscription) {
            this.dynamicRTLSubscription.unsubscribe();
        }
    }
}
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
CardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardComponent, selectors: [["kendo-card"]], hostVars: 11, hostBindings: function CardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dir", ctx.direction);
        ɵngcc0.ɵɵstyleProp("width", ctx.widthStyle);
        ɵngcc0.ɵɵclassProp("k-widget", ctx.hostClass)("k-card", ctx.hostClass)("k-card-vertical", ctx.vertical)("k-card-horizontal", ctx.horizontal);
    } }, inputs: { orientation: "orientation", width: "width" }, features: [ɵngcc0.ɵɵProvidersFeature([
            LocalizationService,
            {
                provide: L10N_PREFIX,
                useValue: 'kendo.card.component'
            }
        ])], ngContentSelectors: _c6, decls: 1, vars: 0, template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/** @nocollapse */
CardComponent.ctorParameters = () => [
    { type: LocalizationService }
];
CardComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-widget',] }, { type: HostBinding, args: ['class.k-card',] }],
    widthStyle: [{ type: HostBinding, args: ['style.width',] }],
    vertical: [{ type: HostBinding, args: ['class.k-card-vertical',] }],
    horizontal: [{ type: HostBinding, args: ['class.k-card-horizontal',] }],
    direction: [{ type: HostBinding, args: ['attr.dir',] }],
    orientation: [{ type: Input }],
    width: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-card',
                providers: [
                    LocalizationService,
                    {
                        provide: L10N_PREFIX,
                        useValue: 'kendo.card.component'
                    }
                ],
                template: `
        <ng-content></ng-content>
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-widget']
        }, {
            type: HostBinding,
            args: ['class.k-card']
        }], orientation: [{
            type: Input
        }], width: [{
            type: Input
        }], direction: [{
            type: HostBinding,
            args: ['attr.dir']
        }], widthStyle: [{
            type: HostBinding,
            args: ['style.width']
        }], vertical: [{
            type: HostBinding,
            args: ['class.k-card-vertical']
        }], horizontal: [{
            type: HostBinding,
            args: ['class.k-card-horizontal']
        }] }); })();

/**
 * Specifies the content in the Card header.
 */
class CardHeaderComponent {
    constructor() {
        this.hostClass = true;
    }
}
CardHeaderComponent.ɵfac = function CardHeaderComponent_Factory(t) { return new (t || CardHeaderComponent)(); };
CardHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardHeaderComponent, selectors: [["kendo-card-header"]], hostVars: 2, hostBindings: function CardHeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-header", ctx.hostClass);
    } }, ngContentSelectors: _c6, decls: 1, vars: 0, template: function CardHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
CardHeaderComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-header',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-card-header',
                template: `
        <ng-content></ng-content>
    `
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-header']
        }] }); })();

/**
 * Specifies the content in the Card body.
 */
class CardBodyComponent {
    constructor() {
        this.hostClass = true;
    }
}
CardBodyComponent.ɵfac = function CardBodyComponent_Factory(t) { return new (t || CardBodyComponent)(); };
CardBodyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardBodyComponent, selectors: [["kendo-card-body"]], hostVars: 2, hostBindings: function CardBodyComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-body", ctx.hostClass);
    } }, ngContentSelectors: _c6, decls: 1, vars: 0, template: function CardBodyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
CardBodyComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-body',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardBodyComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-card-body',
                template: `
        <ng-content></ng-content>
    `
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-body']
        }] }); })();

/**
 * Specifies the content in the Card footer.
 */
class CardFooterComponent {
    constructor() {
        this.hostClass = true;
    }
}
CardFooterComponent.ɵfac = function CardFooterComponent_Factory(t) { return new (t || CardFooterComponent)(); };
CardFooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardFooterComponent, selectors: [["kendo-card-footer"]], hostVars: 2, hostBindings: function CardFooterComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-footer", ctx.hostClass);
    } }, ngContentSelectors: _c6, decls: 1, vars: 0, template: function CardFooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
CardFooterComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-footer',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardFooterComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-card-footer',
                template: `
        <ng-content></ng-content>
    `
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-footer']
        }] }); })();

/**
 * Specifies the action buttons of the Card.
 * * ([see example]({% slug actions_card %})).
 */
class CardActionsComponent {
    constructor() {
        this.hostClass = true;
        /**
         * Specifies the layout of the Card action buttons.
         *
         * * The possible values are:
         * * (Default) `horizontal`
         * * `vertical`
         *
         */
        this.orientation = 'horizontal';
        /**
         * Specifies the layout of the Card action buttons.
         *
         * The possible values are:
         * * (Default) `start`
         * * `center`
         * * `end`
         * * `stretched`
         *
         */
        this.layout = 'start';
        /**
         * Fires when the user clicks an action button.
         */
        this.action = new EventEmitter();
    }
    get stretchedClass() {
        return this.layout === 'stretched';
    }
    get startClass() {
        return this.layout === 'start';
    }
    get endClass() {
        return this.layout === 'end';
    }
    get centerClass() {
        return this.layout === 'center';
    }
    get verticalClass() {
        return this.orientation === 'vertical';
    }
    get horizontalClass() {
        return this.orientation === 'horizontal';
    }
    /**
     * @hidden
     */
    onClick(action) {
        this.action.emit(action);
    }
    /**
     * @hidden
     */
    actionTemplate() {
        return this.actions instanceof TemplateRef;
    }
}
CardActionsComponent.ɵfac = function CardActionsComponent_Factory(t) { return new (t || CardActionsComponent)(); };
CardActionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CardActionsComponent, selectors: [["kendo-card-actions"]], hostVars: 14, hostBindings: function CardActionsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-actions", ctx.hostClass)("k-card-actions-stretched", ctx.stretchedClass)("k-card-actions-start", ctx.startClass)("k-card-actions-end", ctx.endClass)("k-card-actions-center", ctx.centerClass)("k-card-actions-vertical", ctx.verticalClass)("k-card-actions-horizontal", ctx.horizontalClass);
    } }, inputs: { orientation: "orientation", layout: "layout", actions: "actions" }, outputs: { action: "action" }, ngContentSelectors: _c6, decls: 3, vars: 3, consts: [[4, "ngIf"], ["type", "button", "class", "k-button", 3, "k-primary", "k-flat", "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "k-button", 3, "click"], [3, "ngTemplateOutlet"]], template: function CardActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CardActionsComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
        ɵngcc0.ɵɵtemplate(1, CardActionsComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, CardActionsComponent_2_Template, 1, 1, undefined, 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.actions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.actionTemplate());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionTemplate());
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
CardActionsComponent.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-actions',] }],
    stretchedClass: [{ type: HostBinding, args: ['class.k-card-actions-stretched',] }],
    startClass: [{ type: HostBinding, args: ['class.k-card-actions-start',] }],
    endClass: [{ type: HostBinding, args: ['class.k-card-actions-end',] }],
    centerClass: [{ type: HostBinding, args: ['class.k-card-actions-center',] }],
    verticalClass: [{ type: HostBinding, args: ['class.k-card-actions-vertical',] }],
    horizontalClass: [{ type: HostBinding, args: ['class.k-card-actions-horizontal',] }],
    orientation: [{ type: Input }],
    layout: [{ type: Input }],
    actions: [{ type: Input }],
    action: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardActionsComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-card-actions',
                template: `
        <ng-content *ngIf="!actions"></ng-content>

        <ng-container *ngIf="!actionTemplate()">
            <button type="button"
                class="k-button"
                [class.k-primary]="action.primary"
                [class.k-flat]="action.flat"
                (click)="onClick(action)"
                *ngFor="let action of actions"
            >
                {{ action.text }}
            </button>
        </ng-container>

        <ng-template [ngTemplateOutlet]="actions" *ngIf="actionTemplate()"></ng-template>
    `
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-actions']
        }], orientation: [{
            type: Input
        }], layout: [{
            type: Input
        }], action: [{
            type: Output
        }], stretchedClass: [{
            type: HostBinding,
            args: ['class.k-card-actions-stretched']
        }], startClass: [{
            type: HostBinding,
            args: ['class.k-card-actions-start']
        }], endClass: [{
            type: HostBinding,
            args: ['class.k-card-actions-end']
        }], centerClass: [{
            type: HostBinding,
            args: ['class.k-card-actions-center']
        }], verticalClass: [{
            type: HostBinding,
            args: ['class.k-card-actions-vertical']
        }], horizontalClass: [{
            type: HostBinding,
            args: ['class.k-card-actions-horizontal']
        }], actions: [{
            type: Input
        }] }); })();

/**
 * Specifies a separator in the content of the Card.
 */
class CardSeparatorDirective {
    constructor() {
        this.hostClass = true;
        /**
         * Specifies the orientation of the Card separator.
         *
         * The possible values are:
         * (Default) `horizontal`
         * `vertical`
         */
        this.orientation = 'horizontal';
    }
    get verticalClass() {
        return this.orientation === 'vertical';
    }
    get horizontalClass() {
        return this.orientation === 'horizontal';
    }
}
CardSeparatorDirective.ɵfac = function CardSeparatorDirective_Factory(t) { return new (t || CardSeparatorDirective)(); };
CardSeparatorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CardSeparatorDirective, selectors: [["", "kendoCardSeparator", ""]], hostVars: 8, hostBindings: function CardSeparatorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("color", ctx.color);
        ɵngcc0.ɵɵclassProp("k-card-separator", ctx.hostClass)("k-separator-vertical", ctx.verticalClass)("k-separator-horizontal", ctx.horizontalClass);
    } }, inputs: { orientation: "orientation", color: "color" } });
CardSeparatorDirective.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-separator',] }],
    verticalClass: [{ type: HostBinding, args: ['class.k-separator-vertical',] }],
    horizontalClass: [{ type: HostBinding, args: ['class.k-separator-horizontal',] }],
    color: [{ type: HostBinding, args: ['style.color',] }, { type: Input }],
    orientation: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardSeparatorDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoCardSeparator]'
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-separator']
        }], orientation: [{
            type: Input
        }], verticalClass: [{
            type: HostBinding,
            args: ['class.k-separator-vertical']
        }], horizontalClass: [{
            type: HostBinding,
            args: ['class.k-separator-horizontal']
        }], color: [{
            type: HostBinding,
            args: ['style.color']
        }, {
            type: Input
        }] }); })();

/**
 * Specifies the text and styles for the title of the Card.
 */
class CardTitleDirective {
    constructor() {
        this.hostClass = true;
    }
}
CardTitleDirective.ɵfac = function CardTitleDirective_Factory(t) { return new (t || CardTitleDirective)(); };
CardTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CardTitleDirective, selectors: [["", "kendoCardTitle", ""]], hostVars: 2, hostBindings: function CardTitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-title", ctx.hostClass);
    } } });
CardTitleDirective.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-title',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoCardTitle]'
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-title']
        }] }); })();

/**
 * Specifies the text and styles for the subtitle of the Card.
 */
class CardSubtitleDirective {
    constructor() {
        this.hostClass = true;
    }
}
CardSubtitleDirective.ɵfac = function CardSubtitleDirective_Factory(t) { return new (t || CardSubtitleDirective)(); };
CardSubtitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CardSubtitleDirective, selectors: [["", "kendoCardSubtitle", ""]], hostVars: 2, hostBindings: function CardSubtitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-subtitle", ctx.hostClass);
    } } });
CardSubtitleDirective.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-subtitle',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardSubtitleDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoCardSubtitle]'
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-subtitle']
        }] }); })();

/**
 * Specifies any media that will be displayed and aligned in the Card.
 */
class CardMediaDirective {
    constructor() {
        this.hostClass = true;
    }
}
CardMediaDirective.ɵfac = function CardMediaDirective_Factory(t) { return new (t || CardMediaDirective)(); };
CardMediaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CardMediaDirective, selectors: [["", "kendoCardMedia", ""]], hostVars: 2, hostBindings: function CardMediaDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-card-media", ctx.hostClass);
    } } });
CardMediaDirective.propDecorators = {
    hostClass: [{ type: HostBinding, args: ['class.k-card-media',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardMediaDirective, [{
        type: Directive,
        args: [{
                selector: '[kendoCardMedia]'
            }]
    }], function () { return []; }, { hostClass: [{
            type: HostBinding,
            args: ['class.k-card-media']
        }] }); })();

/**
 * The settings of the Card action buttons.
 */
class CardAction {
}

const exportedModules = [
    AvatarComponent
];
const declarations = [
    ...exportedModules
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Avatar component.
 */
class AvatarModule {
}
AvatarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AvatarModule });
AvatarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AvatarModule_Factory(t) { return new (t || AvatarModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AvatarModule, { declarations: function () { return [AvatarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AvatarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AvatarModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations],
                exports: [exportedModules],
                imports: [CommonModule]
            }]
    }], null, null); })();

const cardDirectives = [
    CardTitleDirective,
    CardSubtitleDirective,
    CardSeparatorDirective,
    CardMediaDirective
];
const exportedModules$1 = [
    CardComponent,
    CardHeaderComponent,
    CardBodyComponent,
    CardFooterComponent,
    CardActionsComponent,
    ...cardDirectives
];
const declarations$1 = [...exportedModules$1];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Card component.
 */
class CardModule {
}
CardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CardModule });
CardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CardModule_Factory(t) { return new (t || CardModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardModule, { declarations: function () { return [CardComponent, CardHeaderComponent, CardBodyComponent, CardFooterComponent, CardActionsComponent, CardTitleDirective, CardSubtitleDirective, CardSeparatorDirective, CardMediaDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CardComponent, CardHeaderComponent, CardBodyComponent, CardFooterComponent, CardActionsComponent, CardTitleDirective, CardSubtitleDirective, CardSeparatorDirective, CardMediaDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CardModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations$1],
                exports: [exportedModules$1],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * @hidden
 */
const DRAWER_LINK_SELECTOR = '.k-drawer-link';
/**
 * @hidden
 */
const ACTIVE_NESTED_LINK_SELECTOR = ':focus:not(.k-state-disabled) .k-drawer-link';
/**
 * @hidden
 */
const nestedLink = (element, selector) => element.querySelector(selector);

/**
 * @hidden
 */
class DrawerItemComponent {
    constructor(drawer, element, renderer) {
        this.drawer = drawer;
        this.element = element;
        this.renderer = renderer;
    }
    get disabledClass() {
        return this.item.disabled;
    }
    get selectedClass() {
        return this.drawer.selectedIndices.indexOf(this.index) >= 0;
    }
    get label() {
        return this.item.text ? this.item.text : null;
    }
    /**
     * @hidden
     */
    ngAfterViewInit() {
        const link = nestedLink(this.element.nativeElement, DRAWER_LINK_SELECTOR);
        if (link) {
            this.renderer.removeAttribute(link, 'tabindex');
        }
    }
    /**
     * @hidden
     */
    iconClasses(icon) {
        return `k-icon ${icon}`;
    }
}
DrawerItemComponent.ɵfac = function DrawerItemComponent_Factory(t) { return new (t || DrawerItemComponent)(ɵngcc0.ɵɵdirectiveInject(DrawerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DrawerItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DrawerItemComponent, selectors: [["", "kendoDrawerItem", ""]], hostVars: 7, hostBindings: function DrawerItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-disabled", ctx.disabledClass)("aria-selected", ctx.selectedClass)("aria-label", ctx.label);
        ɵngcc0.ɵɵclassProp("k-state-disabled", ctx.disabledClass)("k-state-selected", ctx.selectedClass);
    } }, inputs: { item: "item", index: "index", itemTemplate: "itemTemplate", mini: "mini", expanded: "expanded", disabled: "disabled", cssClass: "cssClass", cssStyle: "cssStyle" }, attrs: _c14, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["defaultTemplate", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf"], [3, "ngClass"], [1, "k-item-text"]], template: function DrawerItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DrawerItemComponent_0_Template, 1, 4, undefined, 0);
        ɵngcc0.ɵɵtemplate(1, DrawerItemComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemTemplate)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgClass], encapsulation: 2 });
/** @nocollapse */
DrawerItemComponent.ctorParameters = () => [
    { type: DrawerService },
    { type: ElementRef },
    { type: Renderer2 }
];
DrawerItemComponent.propDecorators = {
    item: [{ type: Input }],
    index: [{ type: Input }],
    itemTemplate: [{ type: Input }],
    mini: [{ type: Input }],
    expanded: [{ type: Input }],
    disabled: [{ type: Input }],
    cssClass: [{ type: Input }],
    cssStyle: [{ type: Input }],
    disabledClass: [{ type: HostBinding, args: ['attr.aria-disabled',] }, { type: HostBinding, args: ['class.k-state-disabled',] }],
    selectedClass: [{ type: HostBinding, args: ['attr.aria-selected',] }, { type: HostBinding, args: ['class.k-state-selected',] }],
    label: [{ type: HostBinding, args: ['attr.aria-label',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerItemComponent, [{
        type: Component,
        args: [{
                selector: '[kendoDrawerItem]',
                template: `
        <ng-template *ngIf="itemTemplate; else defaultTemplate"
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }">
        </ng-template>

        <ng-template #defaultTemplate>
            <ng-container *ngIf="expanded">
                <span [ngClass]="iconClasses(item.icon)"></span>
                <span class="k-item-text">{{ item.text }}</span>
            </ng-container>
            <ng-container *ngIf="mini && !expanded">
                <span [ngClass]="iconClasses(item.icon)"></span>
            </ng-container>
        </ng-template>
    `
            }]
    }], function () { return [{ type: DrawerService }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { disabledClass: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }, {
            type: HostBinding,
            args: ['class.k-state-disabled']
        }], selectedClass: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }, {
            type: HostBinding,
            args: ['class.k-state-selected']
        }], label: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], item: [{
            type: Input
        }], index: [{
            type: Input
        }], itemTemplate: [{
            type: Input
        }], mini: [{
            type: Input
        }], expanded: [{
            type: Input
        }], disabled: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], cssStyle: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
const DRAWER_ITEM_INDEX = 'data-kendo-drawer-index';

/**
 * @hidden
 */
class DrawerListComponent {
    constructor(drawerService, renderer, ngZone, changeDetector, element) {
        this.drawerService = drawerService;
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.element = element;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.initialSelection();
        this.initDomEvents();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    initialSelection() {
        /* Differentiates a user selected item */
        if (this.drawerService.selectedIndices.length === 0) {
            this.drawerService.initSelection();
        }
    }
    initDomEvents() {
        if (!this.element) {
            return;
        }
        this.ngZone.runOutsideAngular(() => {
            const nativeElement = this.element.nativeElement;
            this.subscriptions.add(this.renderer.listen(nativeElement, 'click', this.clickHandler.bind(this)));
            this.subscriptions.add(this.renderer.listen(nativeElement, 'keydown', this.keyDownHandler.bind(this)));
        });
    }
    clickHandler(e) {
        const itemIdx = this.getDrawerItemIndex(e.target);
        const item = this.items[itemIdx];
        if (!item) {
            return;
        }
        if (item.disabled) {
            e.preventDefault();
            return;
        }
        const args = {
            index: itemIdx,
            item: item,
            originalEvent: e
        };
        this.ngZone.run(() => {
            if (!this.drawerService.emit('select', args)) {
                this.drawerService.onSelect(itemIdx);
                this.changeDetector.detectChanges();
            }
        });
    }
    keyDownHandler(e) {
        const isEnterOrSpace = e.keyCode === Keys.Enter || e.keyCode === Keys.Space;
        if (!isEnterOrSpace) {
            return;
        }
        this.clickHandler(e);
        const link = nestedLink(this.element.nativeElement, ACTIVE_NESTED_LINK_SELECTOR);
        if (link) {
            link.click();
        }
        return false;
    }
    getDrawerItemIndex(target) {
        const item = closestItem(target, DRAWER_ITEM_INDEX, this.element.nativeElement);
        if (item) {
            return itemIndex(item, DRAWER_ITEM_INDEX);
        }
    }
}
DrawerListComponent.ɵfac = function DrawerListComponent_Factory(t) { return new (t || DrawerListComponent)(ɵngcc0.ɵɵdirectiveInject(DrawerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DrawerListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DrawerListComponent, selectors: [["", "kendoDrawerList", ""]], inputs: { items: "items", itemTemplate: "itemTemplate", mini: "mini", expanded: "expanded" }, attrs: _c15, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["kendoDrawerItem", "", "class", "k-drawer-item", "tabindex", "0", 3, "item", "index", "mini", "expanded", "itemTemplate", "ngClass", "ngStyle", 4, "ngIf"], ["class", "k-drawer-item k-drawer-separator", 3, "ngClass", "ngStyle", 4, "ngIf"], ["kendoDrawerItem", "", "tabindex", "0", 1, "k-drawer-item", 3, "item", "index", "mini", "expanded", "itemTemplate", "ngClass", "ngStyle"], [1, "k-drawer-item", "k-drawer-separator", 3, "ngClass", "ngStyle"]], template: function DrawerListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DrawerListComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, DrawerItemComponent, ɵngcc1.NgClass, ɵngcc1.NgStyle], encapsulation: 2 });
/** @nocollapse */
DrawerListComponent.ctorParameters = () => [
    { type: DrawerService },
    { type: Renderer2 },
    { type: NgZone },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
DrawerListComponent.propDecorators = {
    items: [{ type: Input }],
    itemTemplate: [{ type: Input }],
    mini: [{ type: Input }],
    expanded: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerListComponent, [{
        type: Component,
        args: [{
                selector: '[kendoDrawerList]',
                template: `
        <ng-container *ngFor="let item of items; let idx = index">
            <li *ngIf="!item.separator" kendoDrawerItem
                class="k-drawer-item"
                [item]="item"
                [index]="idx"
                [mini]="mini"
                [expanded]="expanded"
                [itemTemplate]="itemTemplate"
                [attr.${DRAWER_ITEM_INDEX}]="idx"
                [ngClass]="item.cssClass"
                [ngStyle]="item.cssStyle"
                tabindex="0">
            </li>

            <li *ngIf="item.separator"
                class="k-drawer-item k-drawer-separator"
                [ngClass]="item.cssClass"
                [ngStyle]="item.cssStyle">
                &nbsp;
            </li>
        </ng-container>
    `
            }]
    }], function () { return [{ type: DrawerService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { items: [{
            type: Input
        }], itemTemplate: [{
            type: Input
        }], mini: [{
            type: Input
        }], expanded: [{
            type: Input
        }] }); })();

const templateDirectives = [
    DrawerTemplateDirective,
    DrawerHeaderTemplateDirective,
    DrawerFooterTemplateDirective,
    DrawerItemTemplateDirective
];
const exportedModules$2 = [
    DrawerComponent,
    DrawerContainerComponent,
    DrawerContentComponent,
    ...templateDirectives
];
const declarations$2 = [
    DrawerItemComponent,
    DrawerListComponent,
    ...exportedModules$2
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Drawer component.
 */
class DrawerModule {
}
DrawerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DrawerModule });
DrawerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DrawerModule_Factory(t) { return new (t || DrawerModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DrawerModule, { declarations: function () { return [DrawerItemComponent, DrawerListComponent, DrawerComponent, DrawerContainerComponent, DrawerContentComponent, DrawerTemplateDirective, DrawerHeaderTemplateDirective, DrawerFooterTemplateDirective, DrawerItemTemplateDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DrawerComponent, DrawerContainerComponent, DrawerContentComponent, DrawerTemplateDirective, DrawerHeaderTemplateDirective, DrawerFooterTemplateDirective, DrawerItemTemplateDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DrawerModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations$2],
                exports: [exportedModules$2],
                imports: [CommonModule]
            }]
    }], null, null); })();

const exportedModules$3 = [
    PanelBarComponent,
    PanelBarItemComponent,
    PanelBarContentDirective,
    PanelBarItemTemplateDirective,
    PanelBarItemTitleDirective
];
const declarations$3 = [
    ...exportedModules$3
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the PanelBar component.
 *
 * The module registers:
 * - `PanelBarComponent`&mdash;The `PanelBar` component class.
 * - `PanelBarItemComponent`&mdash;The `PanelBarItem` component class.
 * - `PanelBarContentComponent`&mdash;The `PanelBarContent` component class.
 * - `PanelBarItemTemplateDirective&mdash;The `PanelBarItemTemplate` directive.
 * - `PanelBarItemTitleDirective&mdash;The `PanelBarItemTitle` directive.
 */
class PanelBarModule {
}
PanelBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PanelBarModule });
PanelBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PanelBarModule_Factory(t) { return new (t || PanelBarModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PanelBarModule, { declarations: function () { return [PanelBarComponent, PanelBarItemComponent, PanelBarContentDirective, PanelBarItemTemplateDirective, PanelBarItemTitleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PanelBarComponent, PanelBarItemComponent, PanelBarContentDirective, PanelBarItemTemplateDirective, PanelBarItemTitleDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PanelBarModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations$3],
                exports: [exportedModules$3],
                imports: [CommonModule]
            }]
    }], null, null); })();

const stopPropagation = ({ originalEvent: event }) => {
    event.stopPropagation();
    event.preventDefault();
};
const preventOnDblClick = release => mouseDown => of(mouseDown).pipe(delay(150), takeUntil(release));
const classFromObject = classes => Object.keys(classes).filter(c => classes[c]).join(' ');
const createMoveStream = (draggable) => mouseDown => draggable.kendoDrag
    .pipe(takeUntil(draggable.kendoRelease), map(({ pageX, pageY }) => ({
    originalX: mouseDown.pageX,
    originalY: mouseDown.pageY,
    pageX,
    pageY
})));
/**
 * @hidden
 */
class SplitterBarComponent {
    constructor(draggable, splitter, localization) {
        this.draggable = draggable;
        this.splitter = splitter;
        this.localization = localization;
        this.orientation = 'horizontal';
        this.index = 0;
        this.ariaRole = 'separator';
        this.focused = false;
        this.subscriptions = new Subscription();
    }
    get direction() {
        return this.localization.rtl ? 'rtl' : 'ltr';
    }
    get tabIndex() {
        return this.splitter.isStatic(this.index) ? -1 : 0;
    }
    get hostClasses() {
        const isHorizontal = this.orientation === 'horizontal';
        const isDraggable = this.splitter.isDraggable(this.index);
        const isStatic = this.splitter.isStatic(this.index);
        return classFromObject({
            'k-state-focused': this.focused,
            'k-splitbar': true,
            'k-splitbar-horizontal': isHorizontal,
            'k-splitbar-vertical': !isHorizontal,
            'k-splitbar-draggable-horizontal': isHorizontal && isDraggable,
            'k-splitbar-draggable-vertical': !isHorizontal && isDraggable,
            'k-splitbar-static-horizontal': isHorizontal && isStatic,
            'k-splitbar-static-vertical': !isHorizontal && isStatic
        });
    }
    get touchAction() {
        if (this.splitter.isDraggable(this.index)) {
            return 'none';
        }
    }
    get order() {
        return 2 * this.index + 1;
    }
    collapseAny() {
        if (this.expandLast) {
            this.toggleNext();
        }
        else {
            this.tryToggleNearest();
        }
    }
    onFocusIn() {
        this.focused = true;
    }
    onFocusOut() {
        this.focused = false;
    }
    onKeyDown(event) {
        const keyCode = event && event.keyCode;
        const isHorizontal = this.orientation === 'horizontal';
        const resize = delta => {
            event.preventDefault();
            const state$$1 = this.splitter.dragState(this.index);
            this.splitter.setSize(state$$1, delta);
        };
        if (keyCode === Keys.Enter) {
            event.preventDefault();
            this.collapseAny();
        }
        else if (isHorizontal && keyCode === Keys.ArrowLeft) {
            resize(-10);
        }
        else if (isHorizontal && keyCode === Keys.ArrowRight) {
            resize(10);
        }
        else if (!isHorizontal && keyCode === Keys.ArrowUp) {
            resize(-10);
        }
        else if (!isHorizontal && keyCode === Keys.ArrowDown) {
            resize(10);
        }
    }
    get expandLast() {
        const panes = this.splitter.panes;
        return panes.length === 2 && panes[1].collapsed;
    }
    ngOnInit() {
        let state$$1;
        const listener = this.draggable.kendoPress.pipe(tap(stopPropagation), filter(() => this.splitter.isDraggable(this.index)), tap(() => state$$1 = this.splitter.dragState(this.index)), tap(() => this.splitter.toggleContentOverlay(this.index, true)), switchMap(preventOnDblClick(this.draggable.kendoRelease)), switchMap(createMoveStream(this.draggable))).subscribe(({ pageX, pageY, originalX, originalY }) => {
            let delta;
            if (this.orientation === 'vertical') {
                delta = pageY - originalY;
            }
            else if (this.direction === 'rtl') {
                delta = originalX - pageX;
            }
            else {
                delta = pageX - originalX;
            }
            this.splitter.setSize(state$$1, delta);
        });
        this.subscriptions.add(listener);
        this.subscriptions.add(this.draggable.kendoRelease.subscribe(() => this.splitter.toggleContentOverlay(this.index, false)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
    togglePrevious() {
        this.splitter.tryToggle(this.index);
    }
    toggleNext() {
        this.splitter.tryToggle(this.index + 1);
    }
    previousArrowClass() {
        const pane = this.splitter.pane(this.index);
        const nextPane = this.splitter.pane(this.index + 1);
        const isCollapsible = pane.collapsible;
        const isCollapsed = pane.collapsed;
        const isHorizontal = this.orientation === 'horizontal';
        return classFromObject({
            'k-icon': true,
            'k-hidden': !isCollapsible || nextPane.isHidden,
            'k-collapse-prev': isCollapsible,
            'k-i-arrow-60-left': isCollapsible && isHorizontal && !isCollapsed,
            'k-i-arrow-60-right': isCollapsible && isHorizontal && isCollapsed,
            'k-i-arrow-60-up': isCollapsible && !isHorizontal && !isCollapsed,
            'k-i-arrow-60-down': isCollapsible && !isHorizontal && isCollapsed
        });
    }
    nextArrowClass() {
        const pane = this.splitter.pane(this.index + 1);
        const prevPane = this.splitter.pane(this.index);
        const isCollapsible = pane.collapsible;
        const isCollapsed = pane.collapsed;
        const isHorizontal = this.orientation === 'horizontal';
        return classFromObject({
            'k-icon': true,
            'k-hidden': !isCollapsible || prevPane.isHidden,
            'k-collapse-next': isCollapsible,
            'k-i-arrow-60-right': isCollapsible && isHorizontal && !isCollapsed,
            'k-i-arrow-60-left': isCollapsible && isHorizontal && isCollapsed,
            'k-i-arrow-60-down': isCollapsible && !isHorizontal && !isCollapsed,
            'k-i-arrow-60-up': isCollapsible && !isHorizontal && isCollapsed
        });
    }
    tryToggleNearest() {
        const prev = this.index;
        const next = this.index + 1;
        if (!this.splitter.tryToggle(prev)) {
            this.splitter.tryToggle(next);
        }
    }
}
SplitterBarComponent.ɵfac = function SplitterBarComponent_Factory(t) { return new (t || SplitterBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.DraggableDirective, 1), ɵngcc0.ɵɵdirectiveInject(SplitterService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
SplitterBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SplitterBarComponent, selectors: [["kendo-splitter-bar"]], hostVars: 13, hostBindings: function SplitterBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dblclick", function SplitterBarComponent_dblclick_HostBindingHandler() { return ctx.collapseAny(); })("focusin", function SplitterBarComponent_focusin_HostBindingHandler() { return ctx.onFocusIn(); })("focusout", function SplitterBarComponent_focusout_HostBindingHandler() { return ctx.onFocusOut(); })("keydown", function SplitterBarComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-orientation", ctx.orientation)("role", ctx.ariaRole)("tabindex", ctx.tabIndex);
        ɵngcc0.ɵɵclassMap(ctx.hostClasses);
        ɵngcc0.ɵɵstyleProp("touch-action", ctx.touchAction)("-ms-flex-order", ctx.order)("order", ctx.order);
        ɵngcc0.ɵɵclassProp("k-state-focused", ctx.focused);
    } }, inputs: { orientation: "orientation", index: "index" }, decls: 3, vars: 4, consts: [[3, "click"], [1, "k-resize-handle"]], template: function SplitterBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function SplitterBarComponent_Template_div_click_0_listener() { return ctx.togglePrevious(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵlistener("click", function SplitterBarComponent_Template_div_click_2_listener() { return ctx.toggleNext(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.previousArrowClass());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.nextArrowClass());
    } }, encapsulation: 2 });
/** @nocollapse */
SplitterBarComponent.ctorParameters = () => [
    { type: DraggableDirective, decorators: [{ type: Host }] },
    { type: SplitterService },
    { type: LocalizationService }
];
SplitterBarComponent.propDecorators = {
    orientation: [{ type: Input }, { type: HostBinding, args: ['attr.aria-orientation',] }],
    index: [{ type: Input }],
    ariaRole: [{ type: HostBinding, args: ['attr.role',] }],
    focused: [{ type: HostBinding, args: ['class.k-state-focused',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    hostClasses: [{ type: HostBinding, args: ['class',] }],
    touchAction: [{ type: HostBinding, args: ['style.touch-action',] }],
    order: [{ type: HostBinding, args: ['style.-ms-flex-order',] }, { type: HostBinding, args: ['style.order',] }],
    collapseAny: [{ type: HostListener, args: ['dblclick',] }],
    onFocusIn: [{ type: HostListener, args: ['focusin',] }],
    onFocusOut: [{ type: HostListener, args: ['focusout',] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SplitterBarComponent, [{
        type: Component,
        args: [{
                selector: 'kendo-splitter-bar',
                template: `
      <div [class]="previousArrowClass()" (click)="togglePrevious()"></div>
      <div class="k-resize-handle"></div>
      <div [class]="nextArrowClass()" (click)="toggleNext()"></div>
    `
            }]
    }], function () { return [{ type: ɵngcc3.DraggableDirective, decorators: [{
                type: Host
            }] }, { type: SplitterService }, { type: ɵngcc2.LocalizationService }]; }, { orientation: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-orientation']
        }], index: [{
            type: Input
        }], ariaRole: [{
            type: HostBinding,
            args: ['attr.role']
        }], focused: [{
            type: HostBinding,
            args: ['class.k-state-focused']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], hostClasses: [{
            type: HostBinding,
            args: ['class']
        }], touchAction: [{
            type: HostBinding,
            args: ['style.touch-action']
        }], order: [{
            type: HostBinding,
            args: ['style.-ms-flex-order']
        }, {
            type: HostBinding,
            args: ['style.order']
        }], collapseAny: [{
            type: HostListener,
            args: ['dblclick']
        }], onFocusIn: [{
            type: HostListener,
            args: ['focusin']
        }], onFocusOut: [{
            type: HostListener,
            args: ['focusout']
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();

const exportedModules$4 = [
    SplitterComponent,
    SplitterPaneComponent
];
const declarations$4 = [
    SplitterBarComponent,
    ...exportedModules$4
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Splitter component.
 *
 * The module registers:
 * - `SplitterComponent`&mdash;The `Splitter` component class.
 * - `SplitterPaneComponent`&mdash;The `SplitterPane` component class.
 */
class SplitterModule {
}
SplitterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SplitterModule });
SplitterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SplitterModule_Factory(t) { return new (t || SplitterModule)(); }, imports: [[
            CommonModule,
            DraggableModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SplitterModule, { declarations: function () { return [SplitterBarComponent, SplitterComponent, SplitterPaneComponent]; }, imports: function () { return [CommonModule,
        DraggableModule]; }, exports: function () { return [SplitterComponent, SplitterPaneComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SplitterModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations$4],
                exports: [exportedModules$4],
                imports: [
                    CommonModule,
                    DraggableModule
                ]
            }]
    }], null, null); })();

/**
 * @hidden
 */
class StepperStepComponent {
    constructor(service, localization, ngZone) {
        this.service = service;
        this.localization = localization;
        this.ngZone = ngZone;
        this.isStepValid = undefined;
        this.shouldCheckValidity = undefined;
        this.subs = this.service.focusedStepChange.subscribe(() => {
            this.onFocusedStepChange();
        });
        this.subs.add(this.service.triggerValidation.subscribe(() => {
            this.handleValidityChecks();
        }));
    }
    get errorStepClass() {
        if (isPresent(this.isStepValid)) {
            return !this.isStepValid;
        }
        return false;
    }
    get successStepClass() {
        if (isPresent(this.isStepValid)) {
            return this.isStepValid;
        }
        return false;
    }
    ngOnInit() {
        this.handleValidityChecks();
    }
    ngOnChanges(changes) {
        if (changes.current && !changes.current.firstChange) {
            this.handleValidityChecks();
        }
    }
    ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    onFocusedStepChange() {
        this.ngZone.runOutsideAngular(() => {
            if (this.index === this.service.focusedStep) {
                this.stepLink.nativeElement.focus();
            }
        });
    }
    onFocus() {
        this.service.focus(this.index);
    }
    get tabIndexAttr() {
        const active = this.service.focusedStep || this.service.currentStep;
        return this.index === active ? 0 : -1;
    }
    get indicatorIconClasses() {
        if (this.step.icon) {
            return `k-icon k-i-${this.step.icon}`;
        }
        if (this.step.iconClass) {
            return `${this.step.iconClass}`;
        }
        if (this.shouldCheckValidity) {
            return this.validationIconClasses;
        }
    }
    get showIndicatorIcon() {
        if (this.shouldCheckValidity) {
            return true;
        }
        if (this.step.icon || this.step.iconClass) {
            return true;
        }
        return false;
    }
    get showLabelIcon() {
        if (this.shouldCheckValidity) {
            if (this.type === 'label') {
                return true;
            }
            if (this.step.icon || this.step.iconClass) {
                return true;
            }
        }
        return false;
    }
    get showLabelText() {
        return this.type === 'label' || this.type === 'full';
    }
    get validationIconClasses() {
        if (this.isStepValid) {
            return this.successIcon ? `${this.successIcon}` : 'k-icon k-i-check';
        }
        else {
            return this.errorIcon ? `${this.errorIcon}` : 'k-icon k-i-warning';
        }
    }
    get indicatorText() {
        const text = this.step.text;
        return text ? text : this.index + 1;
    }
    updateStepValidity() {
        if (typeof this.step.isValid === 'boolean') {
            return this.step.isValid;
        }
        if (typeof this.step.isValid === 'function') {
            return this.step.isValid(this.index);
        }
        return undefined;
    }
    get showIndicator() {
        return this.type === 'indicator' || this.type === 'full';
    }
    get showLabel() {
        if (this.type === 'label' || this.type === 'full') {
            return true;
        }
        return this.step.optional;
    }
    get optionalText() {
        return this.localization.get('optional');
    }
    get transitionDuration() {
        return this.service.owner.animationDuration;
    }
    _shouldCheckValidity() {
        if (isPresent(this.step.validate)) {
            if (typeof this.step.validate === 'boolean') {
                return this.step.validate;
            }
            if (typeof this.step.validate === 'function') {
                return this.step.validate(this.index);
            }
        }
        return isPresent(this.step.isValid) && this.index < this.current;
    }
    handleValidityChecks() {
        this.isStepValid = undefined;
        this.shouldCheckValidity = this._shouldCheckValidity();
        if (this.shouldCheckValidity) {
            this.isStepValid = this.updateStepValidity();
        }
    }
}
StepperStepComponent.ɵfac = function StepperStepComponent_Factory(t) { return new (t || StepperStepComponent)(ɵngcc0.ɵɵdirectiveInject(StepperService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
StepperStepComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StepperStepComponent, selectors: [["", "kendoStepperStep", ""]], viewQuery: function StepperStepComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c16, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepLink = _t.first);
    } }, hostVars: 4, hostBindings: function StepperStepComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("k-step-error", ctx.errorStepClass)("k-step-success", ctx.successStepClass);
    } }, inputs: { step: "step", index: "index", current: "current", type: "type", successIcon: "successIcon", errorIcon: "errorIcon", indicatorTemplate: "indicatorTemplate", labelTemplate: "labelTemplate", stepTemplate: "stepTemplate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c17, decls: 4, vars: 6, consts: [["href", "#", 1, "k-step-link", 3, "focus"], ["stepLink", ""], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "k-step-indicator", "aria-hidden", "true", 3, "transition-duration", 4, "ngIf"], ["class", "k-step-label", 4, "ngIf"], ["aria-hidden", "true", 1, "k-step-indicator"], ["class", "k-step-indicator-icon", 3, "ngClass", 4, "ngIf"], ["class", "k-step-indicator-text", 4, "ngIf"], [1, "k-step-indicator-icon", 3, "ngClass"], [1, "k-step-indicator-text"], [1, "k-step-label"], ["class", "k-step-text", 4, "ngIf"], ["aria-hidden", "true", 3, "ngClass", 4, "ngIf"], ["class", "k-step-label-optional", 4, "ngIf"], [1, "k-step-text"], ["aria-hidden", "true", 3, "ngClass"], [1, "k-step-label-optional"]], template: function StepperStepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0, 1);
        ɵngcc0.ɵɵlistener("focus", function StepperStepComponent_Template_a_focus_0_listener() { return ctx.onFocus(); });
        ɵngcc0.ɵɵtemplate(2, StepperStepComponent_2_Template, 1, 5, undefined, 2);
        ɵngcc0.ɵɵtemplate(3, StepperStepComponent_ng_container_3_Template, 3, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabindex", ctx.tabIndexAttr)("title", ctx.step.label)("aria-disabled", ctx.step.disabled)("aria-current", ctx.index === ctx.current ? "step" : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.stepTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.stepTemplate);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgClass], encapsulation: 2 });
/** @nocollapse */
StepperStepComponent.ctorParameters = () => [
    { type: StepperService },
    { type: LocalizationService },
    { type: NgZone }
];
StepperStepComponent.propDecorators = {
    step: [{ type: Input }],
    index: [{ type: Input }],
    current: [{ type: Input }],
    type: [{ type: Input }],
    successIcon: [{ type: Input }],
    errorIcon: [{ type: Input }],
    indicatorTemplate: [{ type: Input }],
    labelTemplate: [{ type: Input }],
    stepTemplate: [{ type: Input }],
    stepLink: [{ type: ViewChild, args: ['stepLink', { static: true },] }],
    errorStepClass: [{ type: HostBinding, args: ['class.k-step-error',] }],
    successStepClass: [{ type: HostBinding, args: ['class.k-step-success',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperStepComponent, [{
        type: Component,
        args: [{
                selector: '[kendoStepperStep]',
                template: `
        <a href='#' class='k-step-link' #stepLink
            [attr.tabindex]='tabIndexAttr'
            [attr.title]='step.label'
            [attr.aria-disabled]='step.disabled'
            [attr.aria-current]='index === current ? "step" : null'
            (focus)='onFocus()'
        >
            <ng-template *ngIf='stepTemplate'
                [ngTemplateOutlet]='stepTemplate'
                [ngTemplateOutletContext]='{ $implicit: step, index: index }'>
            </ng-template>

            <ng-container *ngIf='!stepTemplate'>
                <span *ngIf='showIndicator'
                    class='k-step-indicator'
                    aria-hidden='true'
                    [style.transition-duration.ms]='transitionDuration'
                >
                    <ng-template *ngIf='indicatorTemplate'
                        [ngTemplateOutlet]='indicatorTemplate'
                        [ngTemplateOutletContext]='{ $implicit: step, index: index }'>
                    </ng-template>

                    <ng-container *ngIf='!indicatorTemplate'>
                        <span *ngIf='showIndicatorIcon' class='k-step-indicator-icon' [ngClass]='indicatorIconClasses'></span>
                        <span class='k-step-indicator-text' *ngIf='!showIndicatorIcon'>{{ indicatorText }}</span>
                    </ng-container>
                </span>

                <span class='k-step-label' *ngIf='showLabel'>
                    <ng-template *ngIf='labelTemplate'
                        [ngTemplateOutlet]='labelTemplate'
                        [ngTemplateOutletContext]='{ $implicit: step, index: index }'>
                    </ng-template>

                    <ng-container *ngIf='!labelTemplate'>
                        <span class='k-step-text' *ngIf='showLabelText'>{{ step.label }}</span>
                        <span [ngClass]='validationIconClasses' *ngIf='showLabelIcon' aria-hidden='true'></span>
                        <span class='k-step-label-optional' *ngIf='step.optional'>({{optionalText}})</span>
                    </ng-container>
                </span>
            </ng-container>
        </a>
    `
            }]
    }], function () { return [{ type: StepperService }, { type: ɵngcc2.LocalizationService }, { type: ɵngcc0.NgZone }]; }, { errorStepClass: [{
            type: HostBinding,
            args: ['class.k-step-error']
        }], successStepClass: [{
            type: HostBinding,
            args: ['class.k-step-success']
        }], step: [{
            type: Input
        }], index: [{
            type: Input
        }], current: [{
            type: Input
        }], type: [{
            type: Input
        }], successIcon: [{
            type: Input
        }], errorIcon: [{
            type: Input
        }], indicatorTemplate: [{
            type: Input
        }], labelTemplate: [{
            type: Input
        }], stepTemplate: [{
            type: Input
        }], stepLink: [{
            type: ViewChild,
            args: ['stepLink', { static: true }]
        }] }); })();

/**
 * @hidden
 */
const STEPPER_STEP_INDEX = 'data-kendo-stepper-index';

/**
 * @hidden
 */
class StepperListComponent {
    constructor(renderer, ngZone, service, element) {
        this.renderer = renderer;
        this.ngZone = ngZone;
        this.service = service;
        this.element = element;
    }
    ngOnInit() {
        this.initDomEvents();
    }
    ngOnDestroy() {
        if (this.domSubs) {
            this.domSubs();
        }
    }
    get maxStepWidth() {
        return this.maxStepDimension('width');
    }
    get maxStepHeight() {
        return this.maxStepDimension('height');
    }
    maxStepDimension(dimension) {
        if (dimension === 'width' && this.orientation === 'vertical') {
            return null;
        }
        if (dimension === 'height' && this.orientation === 'horizontal') {
            return null;
        }
        return 100 / this.steps.length;
    }
    initDomEvents() {
        if (!this.element) {
            return;
        }
        this.ngZone.runOutsideAngular(() => {
            const nativeElement = this.element.nativeElement;
            const clickSubscription = this.renderer.listen(nativeElement, 'click', this.clickHandler.bind(this));
            const keydownSubscription = this.renderer.listen(nativeElement, 'keydown', (e) => {
                if (hasClass(e.target, 'k-step-link')) {
                    this.service.keydown(e);
                }
            });
            this.domSubs = () => {
                clickSubscription();
                keydownSubscription();
            };
        });
    }
    clickHandler(e) {
        e.preventDefault();
        const stepIdx = this.getStepIndex(e.target);
        const step = this.steps[stepIdx];
        if (!step || step.disabled) {
            return;
        }
        if (stepIdx === this.currentStep) {
            this.service.focus(stepIdx);
            return;
        }
        if (this.linear && this.service.isPrevOrNextStep(stepIdx) === false) {
            return;
        }
        this.service.onActivate(stepIdx, e);
    }
    getStepIndex(target) {
        const step = closestItem(target, STEPPER_STEP_INDEX, this.element.nativeElement);
        if (step) {
            return itemIndex(step, STEPPER_STEP_INDEX);
        }
    }
}
StepperListComponent.ɵfac = function StepperListComponent_Factory(t) { return new (t || StepperListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(StepperService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
StepperListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StepperListComponent, selectors: [["", "kendoStepperList", ""]], inputs: { linear: "linear", stepType: "stepType", orientation: "orientation", currentStep: "currentStep", steps: "steps", successIcon: "successIcon", errorIcon: "errorIcon", indicatorTemplate: "indicatorTemplate", labelTemplate: "labelTemplate", stepTemplate: "stepTemplate" }, attrs: _c19, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["kendoStepperStep", "", 1, "k-step", 3, "type", "step", "index", "current", "successIcon", "errorIcon", "indicatorTemplate", "labelTemplate", "stepTemplate", "ngClass", "ngStyle"]], template: function StepperListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, StepperListComponent_ng_container_0_Template, 2, 28, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
    } }, directives: [ɵngcc1.NgForOf, StepperStepComponent, ɵngcc1.NgClass, ɵngcc1.NgStyle], encapsulation: 2 });
/** @nocollapse */
StepperListComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: NgZone },
    { type: StepperService },
    { type: ElementRef }
];
StepperListComponent.propDecorators = {
    linear: [{ type: Input }],
    stepType: [{ type: Input }],
    orientation: [{ type: Input }],
    currentStep: [{ type: Input }],
    steps: [{ type: Input }],
    successIcon: [{ type: Input }],
    errorIcon: [{ type: Input }],
    indicatorTemplate: [{ type: Input }],
    labelTemplate: [{ type: Input }],
    stepTemplate: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperListComponent, [{
        type: Component,
        args: [{
                selector: '[kendoStepperList]',
                template: `
        <ng-container *ngFor='let step of steps; let idx = index'>
            <li kendoStepperStep
                [attr.${STEPPER_STEP_INDEX}]='idx'
                [type]='stepType'
                [step]='step'
                [index]='idx'
                [current]='currentStep'
                [successIcon]='successIcon'
                [errorIcon]='errorIcon'
                [indicatorTemplate]='indicatorTemplate'
                [labelTemplate]='labelTemplate'
                [stepTemplate]='stepTemplate'
                class='k-step'
                [class.k-step-first]='idx === 0'
                [class.k-step-last]='idx === steps.length - 1'
                [class.k-step-done]='idx < currentStep'
                [class.k-step-current]='idx === currentStep'
                [class.k-step-optional]='step.optional'
                [class.k-step-disabled]='step.disabled'
                [ngClass]='step.cssClass'
                [ngStyle]='step.cssStyle'
                [style.max-width.%] = 'maxStepWidth'
                [style.max-height.%] = 'maxStepHeight'
            >
            </li>
        </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: StepperService }, { type: ɵngcc0.ElementRef }]; }, { linear: [{
            type: Input
        }], stepType: [{
            type: Input
        }], orientation: [{
            type: Input
        }], currentStep: [{
            type: Input
        }], steps: [{
            type: Input
        }], successIcon: [{
            type: Input
        }], errorIcon: [{
            type: Input
        }], indicatorTemplate: [{
            type: Input
        }], labelTemplate: [{
            type: Input
        }], stepTemplate: [{
            type: Input
        }] }); })();

/**
 * @hidden
 */
class Messages extends ComponentMessages {
}
Messages.ɵfac = function Messages_Factory(t) { return ɵMessages_BaseFactory(t || Messages); };
Messages.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: Messages, inputs: { optional: "optional" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
Messages.propDecorators = {
    optional: [{ type: Input }]
};
const ɵMessages_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(Messages);

/**
 * @hidden
 */
class LocalizedMessagesDirective extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
}
LocalizedMessagesDirective.ɵfac = function LocalizedMessagesDirective_Factory(t) { return new (t || LocalizedMessagesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
LocalizedMessagesDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LocalizedMessagesDirective, selectors: [["", "kendoStepperLocalizedMessages", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => LocalizedMessagesDirective)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LocalizedMessagesDirective.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
        type: Directive,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => LocalizedMessagesDirective)
                    }
                ],
                selector: `
      [kendoStepperLocalizedMessages]
    `
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, null); })();

/**
 * Custom component messages override default component messages
 * ([see example]({% slug rtl_layout %})).
 */
class CustomMessagesComponent extends Messages {
    constructor(service) {
        super();
        this.service = service;
    }
    get override() {
        return true;
    }
}
CustomMessagesComponent.ɵfac = function CustomMessagesComponent_Factory(t) { return new (t || CustomMessagesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LocalizationService)); };
CustomMessagesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CustomMessagesComponent, selectors: [["kendo-stepper-messages"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: Messages,
                useExisting: forwardRef(() => CustomMessagesComponent)
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function CustomMessagesComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
CustomMessagesComponent.ctorParameters = () => [
    { type: LocalizationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomMessagesComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        provide: Messages,
                        useExisting: forwardRef(() => CustomMessagesComponent)
                    }
                ],
                selector: 'kendo-stepper-messages',
                template: ``
            }]
    }], function () { return [{ type: ɵngcc2.LocalizationService }]; }, null); })();

const templateDirectives$1 = [
    StepperStepTemplateDirective,
    StepperLabelTemplateDirective,
    StepperIndicatorTemplateDirective
];
const exportedModules$5 = [
    StepperComponent,
    CustomMessagesComponent,
    ...templateDirectives$1
];
const declarations$5 = [
    StepperStepComponent,
    StepperListComponent,
    LocalizedMessagesDirective,
    ...exportedModules$5
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Stepper component.
 */
class StepperModule {
}
StepperModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: StepperModule });
StepperModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function StepperModule_Factory(t) { return new (t || StepperModule)(); }, imports: [[CommonModule, ProgressBarModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StepperModule, { declarations: function () { return [StepperStepComponent, StepperListComponent, LocalizedMessagesDirective, StepperComponent, CustomMessagesComponent, StepperStepTemplateDirective, StepperLabelTemplateDirective, StepperIndicatorTemplateDirective]; }, imports: function () { return [CommonModule, ProgressBarModule]; }, exports: function () { return [StepperComponent, CustomMessagesComponent, StepperStepTemplateDirective, StepperLabelTemplateDirective, StepperIndicatorTemplateDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations$5],
                exports: [exportedModules$5],
                imports: [CommonModule, ProgressBarModule]
            }]
    }], null, null); })();

const exportedModules$6 = [
    TabStripComponent,
    TabStripTabComponent,
    TabContentDirective,
    TabTitleDirective
];
const declarations$6 = [
    ...exportedModules$6
];
/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the TabStrip component.
 *
 * The module registers:
 * - `TabStripComponent`&mdash;The `TabStrip` component class.
 * - `TabStripTabComponent`&mdash;The `TabStripTab` component class.
 * - `TabContentDirective`&mdash;The tab content directive used on the `<ng-template>` tag.
 * - `TabTitleDirective`&mdash;The tab title directive used on the `<ng-template>` tag.
 */
class TabStripModule {
}
TabStripModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TabStripModule });
TabStripModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TabStripModule_Factory(t) { return new (t || TabStripModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TabStripModule, { declarations: function () { return [TabStripComponent, TabStripTabComponent, TabContentDirective, TabTitleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TabStripComponent, TabStripTabComponent, TabContentDirective, TabTitleDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabStripModule, [{
        type: NgModule,
        args: [{
                declarations: [declarations$6],
                exports: [exportedModules$6],
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * Represents the [NgModule]({{ site.data.urls.angular['ngmoduleapi'] }})
 * definition for the Layout components.
 *
 * @example
 *
 * ```ts-no-run
 * // Import the Layout module
 * import { LayoutModule } from '@progress/kendo-angular-layout';
 *
 * // The browser platform with a compiler
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 *
 * import { NgModule } from '@angular/core';
 *
 * // Import the app component
 * import { AppComponent } from './app.component';
 *
 * // Define the app module
 * _@NgModule({
 *     declarations: [AppComponent], // declare app component
 *     imports:      [BrowserModule, LayoutModule], // import Layout module
 *     bootstrap:    [AppComponent]
 * })
 * export class AppModule {}
 *
 * // Compile and launch the module
 * platformBrowserDynamic().bootstrapModule(AppModule);
 *
 * ```
 */
class LayoutModule {
}
LayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LayoutModule });
LayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LayoutModule_Factory(t) { return new (t || LayoutModule)(); }, imports: [AvatarModule, CardModule, DrawerModule, PanelBarModule, SplitterModule, StepperModule, TabStripModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LayoutModule, { exports: [AvatarModule, CardModule, DrawerModule, PanelBarModule, SplitterModule, StepperModule, TabStripModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                exports: [
                    AvatarModule,
                    CardModule,
                    DrawerModule,
                    PanelBarModule,
                    SplitterModule,
                    StepperModule,
                    TabStripModule
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { PreventableEvent, DrawerService, DrawerItemComponent, DrawerListComponent, DRAWER_ITEM_INDEX, CustomMessagesComponent, LocalizedMessagesDirective, Messages, PanelBarService, SplitterBarComponent, SplitterService, StepperListComponent, STEPPER_STEP_INDEX, StepperStepComponent, StepperService, PanelBarComponent, PanelBarItemComponent, PanelBarContentDirective, PanelBarItemTemplateDirective, PanelBarItemTitleDirective, PanelBarExpandMode, SplitterComponent, SplitterPaneComponent, TabStripComponent, TabStripTabComponent, TabContentDirective, TabTitleDirective, SelectEvent, DrawerComponent, DrawerContainerComponent, DrawerContentComponent, DrawerSelectEvent, StepperComponent, StepperActivateEvent, AvatarComponent, CardComponent, CardHeaderComponent, CardBodyComponent, CardFooterComponent, CardActionsComponent, CardSeparatorDirective, CardTitleDirective, CardSubtitleDirective, CardMediaDirective, CardAction, AvatarModule, CardModule, DrawerModule, LayoutModule, PanelBarModule, SplitterModule, StepperModule, TabStripModule, DrawerTemplateDirective, DrawerItemTemplateDirective, DrawerHeaderTemplateDirective, DrawerFooterTemplateDirective, StepperIndicatorTemplateDirective, StepperLabelTemplateDirective, StepperStepTemplateDirective };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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